import React, { useEffect, useState, useRef } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  makeStyles,
  Paper,
  CircularProgress,
  IconButton,
  Dialog,
  Typography,
  Grid,
  Box,
  TextField,
  Button,
  DialogContent,
  // DialogActions,
} from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
import Autocomplete from "@material-ui/lab/Autocomplete";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import SaveIcon from "@material-ui/icons/Save";
import ClearIcon from "@material-ui/icons/Clear";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import DragIndicatorIcon from "@material-ui/icons/DragIndicator";
import {
  dateFormated,
  presentFormatedData,
} from "../../functionalComponents/dataFormatFunctions";
import jwt_decode from "jwt-decode";

import axios from "axios";
import { appUrl } from "../../../../../../utils/config";
import { downloadPdfFromBase64 } from "./pdfDownloadUtils";
// import EditRmPmLotMfgStartDate from "../POColumns/EditRmPmLotMfgStartDate";
// import EditRmPmLotMfgDispatchDate from "../POColumns/EditRmPmLotMfgDispatchDate";
// import EditRmPmLotMfgReceiptDate from "../POColumns/EditRmPmLotMfgReceiptDate";
import EditPlannedAllocatedQuantityDialog from "../POColumns/EditPlannedAllocatedQuantityDialog";
import DeleteLotAllocationDialog from "../POColumns/DeleteLotAllocationDialog";
import BatchAllocationElectronicSignature from "./BatchAllocationElectronicSignature";

import WarningIcon from "@material-ui/icons/Warning";
import CloseIcon from "@material-ui/icons/Close";
import FlagIcon from "@material-ui/icons/Flag";
import StyledButton from "../../models/Button";
// import { ChevronRight } from "@material-ui/icons";
// import CheckCircleIcon from "@material-ui/icons/CheckCircle";
// import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import StyledDialog from "../../../../../common/models/Dialog";
import jwtDecode from "jwt-decode";
import ViewRmPmLotTable from "./ViewRmPmLotTable";

const useStyles = makeStyles({
  tableContainer: {
    border: "1px solid #ccc",
    borderRadius: "8px",
    overflow: "auto",
    maxWidth: "100%",
  },
  headerCell: {
    backgroundColor: "#f5f5f5",
    fontWeight: "bold",
    minWidth: "90px",
  },
  avatar: {
    color: "green",
    margin: "0 auto",
    fontSize: "54px",
  },
  dialogContent: {
    textAlign: "center",
    padding: "30px 36px 24px 36px",
  },
  editIconButton: {
    "&.Mui-disabled": {
      "& svg": {
        color: "#ec6535 !important",
        opacity: 0.4,
      },
    },
  },
  blackBorderFieldset: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "black !important",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "black !important",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "black !important",
    },
  },
});

const LotAllocationTable = ({ data, featuresAccess, showPencilIcon, preFetchedData = null }) => {
  const classes = useStyles();
  const tokenData = jwtDecode(localStorage.getItem("authToken"));
  const [lotAllocationData, setLotAllocationData] = useState([]);
  const [lotAllocationRes, setLotAllocationRes] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [error, setError] = useState(false);
  const [selectedLotData, setSelectedLotData] = useState(null);
  const [rmPmCode, setrmPmCode] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  // const [selectedPoDetails, setSelectedPoDetails] = useState(null);

  const [saveFailed, setSaveFailed] = useState(false);
  const [editSuccessDialogOpen, setEditSuccessDialogOpen] = useState(false);
  const [editSuccessMessage, setEditSuccessMessage] = useState("");
  const [showPdfGenerationFlow, setShowPdfGenerationFlow] = useState(true);
  const [deleteSuccessDialogOpen, setDeleteSuccessDialogOpen] = useState(false);
  const [documentId, setDocumentId] = useState("");
  const [bomCode, setBomCode] = useState("");
  const [artworkCode, setArtworkCode] = useState("");
  const [includeDocumentId, setIncludeDocumentId] = useState(true);
  const [includeBomCode, setIncludeBomCode] = useState(true);
  const [includeArtworkCode, setIncludeArtworkCode] = useState(true);
  const [pdfFieldValidationError, setPdfFieldValidationError] = useState("");
  const [shareSuccessDialogOpen, setShareSuccessDialogOpen] = useState(false);
  const [pdfGenerationDialogOpen, setPdfGenerationDialogOpen] = useState(false);
  const [workflowDialogOpen, setWorkflowDialogOpen] = useState(false);
  const [sharingWithoutApproval, setSharingWithoutApproval] = useState(false);
  const [savingWorkflow, setSavingWorkflow] = useState(false);
  const [workflowValidationError, setWorkflowValidationError] = useState("");
  const [isProcessingApproval, setIsProcessingApproval] = useState(false);
  const [approvers, setApprovers] = useState([
    { id: 1, requirement: "Approval", approverOrg: "Internal", assignedMember: "", signature: "Electronic", changeOrder: "" }
  ]);
  const nextApproverID = useRef(2);

  // Team members data from API
  const [teamMembers, setTeamMembers] = useState([]);
  const [teamMembersData, setTeamMembersData] = useState([]); // Store raw user data for email mapping
  
  // Electronic signature and approval state
  const [electronicSignatureDialog, setElectronicSignatureDialog] = useState({
    open: false,
    decision: "", // "Approve" or "Reject"
  });
  const [approveRejectSuccess, setApproveRejectSuccess] = useState({
    open: false,
    type: "",
  });
  
  const [infoDialogOpen, setInfoDialogOpen] = useState(false);
  const [plannedBatchDialog, setPlannedBatchDialog] = useState({
    open: false,
    rowData: null,
    componentData: null,
  });
  const [plannedQtyDialog, setPlannedQtyDialog] = useState({
    open: false,
    componentData: null,
  });
  const [editingBatchRow, setEditingBatchRow] = useState(null);
  const [plannedBatchNumber, setPlannedBatchNumber] = useState("");
  const [editingCountryRow, setEditingCountryRow] = useState(null);
  const [countryOfOrigin, setCountryOfOrigin] = useState("");
  const [overAllocatedComponents, setOverAllocatedComponents] = useState([]);
  const [underAllocatedComponents, setUnderAllocatedComponents] = useState([]);
  const [depleteInstructionComponents, setDepleteInstructionComponents] = useState([]);
  const [batchAllocationPDFNotificationReqd, setBatchAllocationPDFNotificationReqd] = useState(false);

  // Validation function for planned batch number (alphanumeric uppercase only, commas allowed)
  const handlePlannedBatchNumberChange = (e) => {
    const value = e.target.value;
    // Allow alphanumeric, commas, and spaces, convert to uppercase
    const validValue = value.replace(/[^A-Z0-9,\s]/gi, "").toUpperCase();
    setPlannedBatchNumber(validValue);
  };

  // Function to format batch numbers on blur (when user leaves the input)
  const handlePlannedBatchNumberBlur = () => {
    if (!plannedBatchNumber.trim()) return;

    // Clean up: remove empty values, trim spaces, add consistent spacing
    const cleaned = plannedBatchNumber
      .split(",")
      .map((batch) => batch.trim())
      .filter((batch) => batch.length > 0)
      .join(", ");

    setPlannedBatchNumber(cleaned);
  };

  // Delete dialog state
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedLotForDelete, setSelectedLotForDelete] = useState(null);
  const [selectedComponentForDelete, setSelectedComponentForDelete] =
    useState(null);

  const { roleName, organizationName, authToken } = localStorage;
  var token = authToken;
  var decoded = jwt_decode(token);

  const scheduleLineStatusID = data.scheduleLineDetails.scheduleLineStatusID;
  const batchStatusID = data.batchDetails.batchStatusID;
  const showPencilButton =
    showPencilIcon &&
    (scheduleLineStatusID === 25 ||
      scheduleLineStatusID === 29 ||
      scheduleLineStatusID === 31) &&
    (batchStatusID === null ||
      batchStatusID === 1 ||
      batchStatusID === undefined);

  // Common condition for edit icon visibility
  const canEditFields = ((localStorage.collabType === "CMO" && data?.scheduleLineDetails?.editPlannedAllocation && featuresAccess?.editPlannedAllocatedQty) ||
    (localStorage.collabType !== "CMO" && showPencilIcon && data?.scheduleLineDetails?.editPlannedAllocation && featuresAccess?.editPlannedAllocatedQty));

  // Helper function to check if all planned allocated quantities are NA
  const areAllPlannedAllocatedQuantitiesNA = () => {
    if (!lotAllocationData || lotAllocationData.length === 0) return true;

    return lotAllocationData.every(component => {
      if (component?.lotNumberAllocationDetails && component.lotNumberAllocationDetails.length > 0) {
        return component.lotNumberAllocationDetails.every(lot => 
          !lot?.plannedAllocatedQuantity || 
          lot?.plannedAllocatedQuantity === null || 
          lot?.plannedAllocatedQuantity === undefined ||
          lot?.plannedAllocatedQuantity === "NA"
        );
      }
      return true;
    });
  };
  
  const handleLotAllocationStatus = async (type, message = "Component Allocation updated successfully", showPdfFlow = true) => {
    if (type === "success") {
      // Fetch latest data before showing success dialog
      setTableLoading(true);
      await fetchLotAllocationData();
      setEditSuccessMessage(message);
      // Set whether to show PDF generation flow based on the parameter
      setShowPdfGenerationFlow(showPdfFlow);
      setEditSuccessDialogOpen(true);
    } else if (type === "failed") {
      setSaveFailed(true);
    }
  };

  const handleRefreshLotAllocation = () => {
    setTableLoading(true);
    fetchLotAllocationData();
  };

  // Fetch data with polling mechanism to ensure fresh data
  

  const fetchLotAllocationData = async () => {
    let url = "";
    if (
      data?.batchDetails &&
      data?.batchDetails?.bomConsumptionAddedIndicator
    ) {
      // Get batchSize from batchDetails
      const batchSize = data?.batchDetails?.batchSize;
      url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchComponentAllocationPlannedAndActualNew/${data?.batchDetails?.schrockenDeliveryScheduleBatchID}/${batchSize}`;
    } else {
      url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchComponentAllocationForPOLineNew/${data?.scheduleLineDetails?.schrockenSLID}`;
    }

    try {
      const res = await axios.get(url);
      
      if (res.data.status) {
        if (
          data?.batchDetails &&
          data?.batchDetails?.bomConsumptionAddedIndicator
        ) {
          if (res.data.data.length > 0) {
            setLotAllocationData(res.data.data);
          } else {
            setLotAllocationData([]);
            setError(false);
          }
        } else {
          if (res.data.data.componentAllocationDataList.length > 0) {
            setLotAllocationData(res.data.data.componentAllocationDataList);
            setLotAllocationRes(res.data.data);
            // Store the batchAllocationPDFNotificationReqd flag
            setBatchAllocationPDFNotificationReqd(res.data.data.batchAllocationPDFNotificationReqd || false);
          } else {
            setLotAllocationData([]);
            setLotAllocationRes([]);
            setBatchAllocationPDFNotificationReqd(false);
            setError(false);
          }
        }
      } else {
        setError(true); // If API response is not successful
      }
    } catch (err) {
      console.error("Error fetching lot allocation data:", err);
      setError(true);
    } finally {
      setTableLoading(false);
    }
  };

  useEffect(() => {
    // If preFetchedData is provided, use it instead of fetching
    if (preFetchedData !== null) {
      setLotAllocationData(preFetchedData);
      setLotAllocationRes(Array.isArray(preFetchedData) ? { data: preFetchedData } : preFetchedData);
      setTableLoading(false);
      setError(false);
      return;
    }
    
    // Otherwise, fetch the data as usual
    setTableLoading(true);
    fetchLotAllocationData();
  }, [data, preFetchedData]);

  useEffect(() => {
    if (!isProcessingApproval) {
      setTableLoading(true);
      fetchLotAllocationData();
    }
  }, [data, isProcessingApproval]);

  // Fetch team members when PDF generation dialog opens (needed for both approval flows)
  useEffect(() => {
    const fetchTeamMembers = async () => {
      if (pdfGenerationDialogOpen) {
        try {
          const payload = {
            productCode: lotAllocationRes?.boProductCode
          };
          
          const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAssociatedUsers`;
          
          const response = await axios.post(url, payload);
          
          
          // Format team members data for dropdown with email as value
          if (response.data.status && response.data.data) {
            const formattedMembers = response.data.data.map(user => ({
              label: `${user.fullName} (${user.departmentName} - ${user.roleName})`,
              email: user.emailAddress
            }));
            setTeamMembers(formattedMembers);
            // Keep raw data if needed for other purposes
            setTeamMembersData(response.data.data);
          }
        } catch (error) {
          console.error("Error fetching associated users:", error);
        }
      }
    };
    
    fetchTeamMembers();
  }, [pdfGenerationDialogOpen, lotAllocationRes?.boProductCode]);

  // Check for over-allocated and under-allocated components
  useEffect(() => {
    if (lotAllocationData && lotAllocationData.length > 0) {
      const overAllocated = [];
      const underAllocated = [];

      lotAllocationData.forEach((component) => {
        const bomQty = component?.componentAllocationDetails?.componentQuantity;

        // Check if lotNumberAllocationDetails exists and has data
        const hasLotAllocationData =
          component?.lotNumberAllocationDetails &&
          component?.lotNumberAllocationDetails.length > 0;

        if (!hasLotAllocationData) {
          // Skip if no lot allocation data (would show as "NA")
          return;
        }

        const totalPlannedQty =
          component?.lotNumberAllocationDetails?.reduce((sum, lot) => {
            const plannedQty = lot?.plannedAllocatedQuantity;

            if (
              plannedQty === null ||
              plannedQty === undefined ||
              plannedQty === "NA"
            ) {
              return sum;
            }
            return sum + (parseFloat(plannedQty) || 0);
          }, 0) || 0;

        if (totalPlannedQty === 0) {
          return;
        }

        // Round both values to 3 decimals for consistent comparison
        const roundedTotal = Math.round(totalPlannedQty * 1000) / 1000;
        const roundedBomQty = Math.round(bomQty * 1000) / 1000;

        if (roundedTotal > roundedBomQty) {
          overAllocated.push(component);
        } else if (roundedTotal < roundedBomQty) {
          underAllocated.push(component);
        }
      });

      setOverAllocatedComponents(overAllocated);
      setUnderAllocatedComponents(underAllocated);
    } else {
      setOverAllocatedComponents([]);
      setUnderAllocatedComponents([]);
    }
  }, [lotAllocationData]);

  // Check for components with deplete instruction flag
  useEffect(() => {
    if (lotAllocationData && lotAllocationData.length > 0) {
      const depleteComponents = [];

      lotAllocationData.forEach((component) => {
        const lotAllocations = component?.lotNumberAllocationDetails || [];
        
        // Find all lots with addDepleteInstruction flag set to true
        const depleteLots = lotAllocations.filter(
          (lot) => lot?.isDepletedBatch === true
        );

        if (depleteLots.length > 0) {
          // Group batches by component code
          const batches = depleteLots
            .map((lot) => lot?.lotNumber || lot?.cmoLotNumber)
            .filter(Boolean);
          
          if (batches.length > 0) {
            depleteComponents.push({
              componentCode: component?.componentAllocationDetails?.componentCode,
              componentName: component?.componentAllocationDetails?.componentName,
              batches: batches,
            });
          }
        }
      });

      setDepleteInstructionComponents(depleteComponents);
    } else {
      setDepleteInstructionComponents([]);
    }
  }, [lotAllocationData]);

  // Function to open planned qty edit dialog directly (confirmation removed)
  const handleOpenPlannedQtyDialog = (componentData) => {
    // Directly open the edit dialog without confirmation
    setSelectedLotData(componentData);
    setrmPmCode(componentData?.componentAllocationDetails?.componentCode);
    setOpenDialog(true);
  };

  // Function to open dialog with specific inventoryDetails
  const handleOpenDialog = (lotData, rmPmCode) => {
    setSelectedLotData(lotData);
    setrmPmCode(rmPmCode);
    setOpenDialog(true);
  };

  // Function to close dialog
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedLotData(null);
  };

  // Function to open delete dialog
  const handleOpenDeleteDialog = (lot, component) => {
    setSelectedLotForDelete(lot);
    setSelectedComponentForDelete(component);
    setOpenDeleteDialog(true);
  };

  // Function to close delete dialog
  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
    setSelectedLotForDelete(null);
    setSelectedComponentForDelete(null);
  };

  // Handle delete success/failure
  const handleDeleteStatus = (type) => {
    if (type === "success") {
      setDeleteSuccessDialogOpen(true);
    } else if (type === "failed") {
      setSaveFailed(true);
    }
  };

  // Function to open planned batch number edit mode directly (confirmation removed)
  const handleOpenPlannedBatchDialog = (
    rowData,
    componentData,
    componentIndex
  ) => {
    // Directly enable edit mode without confirmation
    const rowKey = `${componentData?.componentAllocationDetails?.componentCode}-${componentIndex}`;
    setEditingBatchRow(rowKey);
    // Pre-populate with existing planned lot numbers if available
    setPlannedBatchNumber(
      componentData?.componentAllocationDetails?.plannedLotNumbers || ""
    );
    // Store the component data for later use in save
    setPlannedBatchDialog({
      open: false,
      rowData: rowData,
      componentData: componentData,
      componentIndex: componentIndex,
    });
  };

  const getOrganizationIdFromToken = () => {
    const authToken = localStorage.getItem("authToken"); // Get token from localStorage
    if (!authToken) return null; // Return null if no token is found

    try {
      const decodedToken = jwtDecode(authToken); // Decode the JWT token
      return decodedToken.collaborator_type_id || null; // Return collaborator_type_id or null if not found
    } catch (error) {
      console.error("Error decoding JWT token:", error);
      return null;
    }
  };
  const collaboratorTypeID = getOrganizationIdFromToken();

  // Function to save planned batch number
  const handleSavePlannedBatch = async () => {
    const componentData = plannedBatchDialog.componentData;
    const existingValue =
      componentData?.componentAllocationDetails?.plannedLotNumbers;

    // Clean up the input: remove trailing/leading commas and extra spaces
    const cleanedBatchNumber = plannedBatchNumber.trim()
      ? plannedBatchNumber
          .split(",")
          .map((batch) => batch.trim())
          .filter((batch) => batch.length > 0)
          .join(", ")
      : "";

    // Allow empty string only if there's an existing value to clear
    // Prevent empty API calls for new entries
    if (!cleanedBatchNumber && !existingValue) {
      return;
    }

    setTableLoading(true);
    try {
      const componentData = plannedBatchDialog.componentData;

      // Check if lotNumber exists in first element
      const lotNumberAllocationDetails = componentData
        ?.lotNumberAllocationDetails?.[0]?.lotNumber
        ? componentData?.lotNumberAllocationDetails?.map((lot) => ({
            lotNumber: lot?.lotNumber,
            plannedAllocatedQuantity: lot?.plannedAllocatedQuantity,
            dispatchDate: lot?.dispatchDate,
            manufacturingStartDate: lot?.manufacturingStartDate,
            lotReceiptDate: lot?.lotReceiptDate,
          }))
        : [];

      const payload = {
        schrockenSLID: data?.scheduleLineDetails?.schrockenSLID,
        cdmoOrgID: data?.scheduleLineDetails?.vendorMosymphonyID,
        lastUpdatedBy: "",
        senderLegalName: "",
        receiverLegalName: "",
        dateChangeFlag: false,
        collabrixProductID: "",
        collaboratorTypeID: collaboratorTypeID,
        overAllocationDone: null,
        updatePlannedBatchFlag: true,
        componentAllocationDataList: [
          {
            componentAllocationDetails: {
              componentCode:
                componentData?.componentAllocationDetails?.componentCode,
              deliveryScheduleLineCounter:
                componentData?.componentAllocationDetails
                  ?.deliveryScheduleLineCounter,
              reasonCode: "",
              comment: "",
              plannedLotNumbers: cleanedBatchNumber,
              // countryOfOrigin: componentData?.componentAllocationDetails?.countryOfOrigin || "",
            },
            previousLotNumberAllocationDetails: [],
            lotNumberAllocationDetails: lotNumberAllocationDetails,
          },
        ],
      };

      const apiUrl = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateComponentAllocationNew`;
      // return
      const response = await axios.post(apiUrl, payload);

      if (response.data.status) {
        setEditingBatchRow(null);
        setPlannedBatchNumber("");
        // Fetch latest data first before showing success dialog
        setTableLoading(true);
        await fetchLotAllocationData();
        handleLotAllocationStatus("success", "Planned Material Batch Number updated successfully", false);
      } else {
        handleLotAllocationStatus("failed");
      }
    } catch (error) {
      console.error("Error saving planned batch number:", error);
      handleLotAllocationStatus("failed");
    } finally {
      setTableLoading(false);
    }
  };

  // Function to cancel editing
  const handleCancelEdit = () => {
    setEditingBatchRow(null);
    setPlannedBatchNumber("");
    setPlannedBatchDialog({
      open: false,
      rowData: null,
      componentData: null,
    });
  };

  // Country of Origin handlers
  const handleCountryOfOriginChange = (e) => {
    const value = e.target.value;
    setCountryOfOrigin(value);
  };

  const handleCountryOfOriginBlur = () => {
    if (!countryOfOrigin.trim()) return;
    const cleaned = countryOfOrigin.trim();
    setCountryOfOrigin(cleaned);
  };

  const handleEditCountryClick = (component, componentIndex) => {
    const rowKey = `${component?.componentAllocationDetails?.componentCode}-${componentIndex}`;
    setEditingCountryRow(rowKey);
    setCountryOfOrigin(
      component?.componentAllocationDetails?.countryOfOrigin || ""
    );
  };

  const handleSaveCountry = async (component) => {
    const existingValue =
      component?.componentAllocationDetails?.countryOfOrigin;
    const cleanedCountry = countryOfOrigin.trim();

    // Allow empty string only if there's an existing value to clear
    // Prevent empty API calls for new entries
    if (!cleanedCountry && !existingValue) {
      return;
    }

    setTableLoading(true);
    try {
      // Check if lotNumber exists in first element
      const lotNumberAllocationDetails = component
        ?.lotNumberAllocationDetails?.[0]?.lotNumber
        ? component?.lotNumberAllocationDetails?.map((lot) => ({
            lotNumber: lot?.lotNumber,
            plannedAllocatedQuantity: lot?.plannedAllocatedQuantity,
            dispatchDate: lot?.dispatchDate,
            manufacturingStartDate: lot?.manufacturingStartDate,
            lotReceiptDate: lot?.lotReceiptDate,
          }))
        : [];

      const payload = {
        schrockenSLID: data?.scheduleLineDetails?.schrockenSLID,
        cdmoOrgID: data?.scheduleLineDetails?.vendorMosymphonyID,
        lastUpdatedBy: "",
        senderLegalName: "",
        receiverLegalName: "",
        dateChangeFlag: false,
        collabrixProductID: "",
        collaboratorTypeID: collaboratorTypeID,
        overAllocationDone: null,
        updateCountryOfOriginFlag: true,
        componentAllocationDataList: [
          {
            componentAllocationDetails: {
              componentCode:
                component?.componentAllocationDetails?.componentCode,
              deliveryScheduleLineCounter:
                component?.componentAllocationDetails
                  ?.deliveryScheduleLineCounter,
              reasonCode: "",
              comment: "",
              countryOfOrigin: cleanedCountry,
              // plannedLotNumbers: component?.componentAllocationDetails?.plannedLotNumbers || "",
            },
            previousLotNumberAllocationDetails: [],
            lotNumberAllocationDetails: lotNumberAllocationDetails,
          },
        ],
      };

      const apiUrl = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateComponentAllocationNew`;

      const response = await axios.post(apiUrl, payload);

      if (response.data.status) {
        setEditingCountryRow(null);
        setCountryOfOrigin("");
        // Fetch latest data first before showing success dialog
        setTableLoading(true);
        await fetchLotAllocationData();
        handleLotAllocationStatus("success", "Country of Origin updated successfully", false);
      } else {
        handleLotAllocationStatus("failed");
      }
    } catch (error) {
      console.error("Error saving country of origin:", error);
      handleLotAllocationStatus("failed");
    } finally {
      setTableLoading(false);
    }
  };

  const handleCancelCountryEdit = () => {
    setEditingCountryRow(null);
    setCountryOfOrigin("");
  };

  // Handle continue to generate PDF (opens PDF generation dialog)
  const handleContinueToGeneratePdf = () => {
    // Close the first success dialog and open PDF generation dialog
    setEditSuccessDialogOpen(false);
    setShowPdfGenerationFlow(true); // Reset to default
    setPdfFieldValidationError("");
    setPdfGenerationDialogOpen(true);
  };

  // Handle share without approvals
  const handleShareWithoutApprovals = async () => {
    // Validate fields
    if (includeDocumentId && !documentId.trim()) {
      setPdfFieldValidationError("Please enter Document ID");
      return;
    }
    if (includeBomCode && !bomCode.trim()) {
      setPdfFieldValidationError("Please enter BoM Code");
      return;
    }
    if (includeArtworkCode && !artworkCode.trim()) {
      setPdfFieldValidationError("Please enter Artwork Code");
      return;
    }
    
    // Clear validation error if all validations pass
    setPdfFieldValidationError("");
    setSharingWithoutApproval(true);
    try {
      // Extract cc array from teamMembersData
      const ccList = teamMembersData.map(user => user.fullName);
      
      // Construct payload from lotAllocationRes
      const payload = {
        boProductCode: lotAllocationRes?.boProductCode,
        cmoProductCode: lotAllocationRes?.cmoProductCode,
        boProductDescription: lotAllocationRes?.boProductDescription,
        cmoProductDescription: lotAllocationRes?.cmoProductDescription,
        collabrixProductID: lotAllocationRes?.collabrixProductID,
        consumptionDataReqdForIBDGRN: lotAllocationRes?.consumptionDataReqdForIBDGRN,
        allocationOwnedBySponsor: lotAllocationRes?.allocationOwnedBySponsor,
        batchAllocationPDFNotificationReqd: lotAllocationRes?.batchAllocationPDFNotificationReqd,
        batchAllocationPDFNotificationSubject: lotAllocationRes?.batchAllocationPDFNotificationSubject,
        batchAllocationPDFNotificationObjective: lotAllocationRes?.batchAllocationPDFNotificationObjective,
        productType: lotAllocationRes?.productType,
        vendorMosymphonyID: lotAllocationRes?.vendorMosymphonyID,
        brandOwnerMosymphonyID: data?.scheduleLineDetails?.brandOwnerMosymphonyID,
        schrockenSLID: data?.scheduleLineDetails?.schrockenSLID,
        collaboratorTypeID,
        vendorPlant: data?.scheduleLineDetails?.vendorPlant,
        storageLocation: data?.scheduleLineDetails?.storageLocation,
        fgMaterialCode: data?.scheduleLineDetails?.fgMaterialCode,
        fgMaterialName: data?.scheduleLineDetails?.fgMaterialName,
        sponsorName: data?.scheduleLineDetails?.sponsorName,
        vendorName: data?.scheduleLineDetails?.vendorName,
        poNumber: data?.scheduleLineDetails?.scheduleAgreementNumber,
        brand: data?.scheduleLineDetails?.brand,
        approvalNotReqd: true,
        approvalWorkflowDetails: [],
        departmentName: localStorage.getItem("departmentName") || "",
        roleName: decodeURIComponent(localStorage.getItem("roleName") || ""),
        cc: ccList,
        documentID: documentId && includeDocumentId ? documentId.trim() : "",
        bomCode: bomCode && includeBomCode ? bomCode.trim() : "",
        artworkCode: artworkCode && includeArtworkCode ? artworkCode.trim() : "",
        generateAllocationPDF: true,
        componentAllocationDataList: lotAllocationRes?.componentAllocationDataList?.map(component => ({
          componentAllocationDetails: {
            componentCode: component?.componentAllocationDetails?.componentCode,
            componentName: component?.componentAllocationDetails?.componentName,
            componentQuantity: component?.componentAllocationDetails?.componentQuantity,
            uom: component?.componentAllocationDetails?.uom,
            lastUpdatedDate: component?.componentAllocationDetails?.lastUpdatedDate,
            deliveryScheduleLineCounter: component?.componentAllocationDetails?.deliveryScheduleLineCounter,
            cmoComponentCode: component?.componentAllocationDetails?.cmoComponentCode,
            cmoComponentName: component?.componentAllocationDetails?.cmoComponentName,
            cmoUOM: component?.componentAllocationDetails?.cmoUOM,
            boUOM: component?.componentAllocationDetails?.boUOM,
            plannedLotNumbers: component?.componentAllocationDetails?.plannedLotNumbers,
            countryOfOrigin: component?.componentAllocationDetails?.countryOfOrigin,
          },
          lotNumberAllocationDetails: component?.lotNumberAllocationDetails?.map(lot => ({
            lotNumber: lot?.lotNumber,
            plannedAllocatedQuantity: lot?.plannedAllocatedQuantity,
            expiryDate: lot?.expiryDate,
            netAvailableQuantity: lot?.netAvailableQuantity,
            dispatchDate: lot?.dispatchDate,
            manufacturingStartDate: lot?.manufacturingStartDate,
            lotReceiptDate: lot?.lotReceiptDate,
            allowMultipleLotAllocation: lot?.allowMultipleLotAllocation,
            allowOverAllocation: lot?.allowOverAllocation,
            overAllocationLimit: lot?.overAllocationLimit,
            cmoLotNumber: lot?.cmoLotNumber,
            boLotNumber: lot?.boLotNumber,
            boPlannedAllocatedQuantity: lot?.boPlannedAllocatedQuantity,
            lastUpdatedDate: lot?.lastUpdatedDate,
            isDepletedBatch: lot?.isDepletedBatch || false,
          })) || [],
          inventoryDetails: component?.inventoryDetails?.map(inv => ({
            inventoryBatchNumber: inv?.inventoryBatchNumber,
            inventoryExpiryDate: inv?.inventoryExpiryDate,
            netAvailableQuantity: inv?.netAvailableQuantity,
            batchNearExpiry: inv?.batchNearExpiry,
          })) || [],
        })) || [],
      };

    

      // Call the API
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/processBatchAllocationWithoutApproval`;
      
      const response = await axios.post(url, payload);
      
      if (response.data.status) {
        // Close PDF generation dialog and show success dialog
        // Fetch updated data once (retry logic removed)
        await fetchLotAllocationData();
        setPdfGenerationDialogOpen(false);
        setPdfFieldValidationError("");
        setEditSuccessMessage("");
        setDocumentId("");
        setBomCode("");
        setArtworkCode("");
        setShareSuccessDialogOpen(true);
      } else {
        // Handle error
        console.error("Failed to process batch allocation:", response.data);
        setSaveFailed(true);
      }
    } catch (error) {
      console.error("Error sharing without approvals:", error);
      setSaveFailed(true);
    } finally {
      setSharingWithoutApproval(false);
    }
  };

  // Handle share after approvals
  const handleShareAfterApprovals = () => {
    // Validate fields
    if (includeDocumentId && !documentId.trim()) {
      setPdfFieldValidationError("Please enter Document ID");
      return;
    }
    if (includeBomCode && !bomCode.trim()) {
      setPdfFieldValidationError("Please enter BoM Code");
      return;
    }
    if (includeArtworkCode && !artworkCode.trim()) {
      setPdfFieldValidationError("Please enter Artwork Code");
      return;
    }
    
    // Clear validation error if all validations pass
    setPdfFieldValidationError("");
    
    // Close PDF generation dialog and open workflow dialog
    // Reset approvers data and clear validation errors (but keep documentId)
    setApprovers([
      { id: 1, requirement: "Approval", approverOrg: "Internal", assignedMember: "", signature: "Electronic", changeOrder: "" }
    ]);
    setWorkflowValidationError("");
    nextApproverID.current = 2;
    // API call to fetch team members will be triggered by useEffect
    setPdfGenerationDialogOpen(false);
    setWorkflowDialogOpen(true);
  };

  // Handle allocate batch for remaining materials/components
  const handleAllocateRemainingMaterials = () => {
    // Close the success dialog so user can continue editing
    setEditSuccessDialogOpen(false);
    setEditSuccessMessage("");
    setShowPdfGenerationFlow(true); // Reset to default
  };

  // Handle add approver
  const handleAddApprover = () => {
    const newApprover = {
      id: nextApproverID.current,
      requirement: "Approval",
      approverOrg: "Internal",
      assignedMember: "",
      signature: "Electronic",
      changeOrder: ""
    };
    nextApproverID.current += 1;
    setApprovers([...approvers, newApprover]);
  };

  // Handle remove approver
  const handleRemoveApprover = (id) => {
    setApprovers(approvers.filter(approver => approver.id !== id));
  };

  // Handle update assigned member
  const handleUpdateAssignedMember = (id, value) => {
    setApprovers(approvers.map(approver => 
      approver.id === id ? { ...approver, assignedMember: value } : approver
    ));
    // Clear validation error when user starts assigning members
    if (value && value.trim() !== "" && workflowValidationError) {
      setWorkflowValidationError("");
    }
  };

  // Handle save workflow
  const handleSaveWorkflow = async () => {
    try {
      // Validate that all approver rows have assigned members
      const unassignedApprovers = approvers.filter(approver => 
        !approver.assignedMember || approver.assignedMember.trim() === ""
      );
      
      if (unassignedApprovers.length > 0) {
        setWorkflowValidationError("Please select an approver for all the rows.");
        return;
      }
      
      // Clear validation error if exists
      setWorkflowValidationError("");
      setSavingWorkflow(true);
      // Check if this is initial approval workflow setup
      const isInitialSetup = !lotAllocationRes?.approvalWorkflowDetails || 
                             lotAllocationRes?.approvalWorkflowDetails.length === 0;
      
      // Map approvers to approval workflow details
      const approvalWorkflowDetails = approvers.map((approver, index) => ({
        requirementType: approver.requirement, // "Approval" or "Review"
        stakeHolderType: approver.approverOrg, // "Internal" or "External"
        decisionBy: approver.assignedMember, // Email address (stored directly)
        eSignatureRequired: approver.signature === "Electronic",
        digitalSignatureRequired: approver.signature === "Digital",
        sequenceNumber: index + 1,
        enableApprovalFlag: true
      }));
      
      // Extract cc array from teamMembersData
      const ccList = teamMembersData.map(user => user.fullName);
      
      // Build request payload
      const payload = {
        batchAllocationSentForApprovalBy:lotAllocationRes?.batchAllocationSentForApprovalBy,
        batchAllocationSentForApprovalDate:lotAllocationRes?.batchAllocationSentForApprovalDate,
        boProductCode: lotAllocationRes?.boProductCode,
        cmoProductCode: lotAllocationRes?.cmoProductCode,
        boProductDescription: lotAllocationRes?.boProductDescription,
        cmoProductDescription: lotAllocationRes?.cmoProductDescription,
        collabrixProductID: lotAllocationRes?.collabrixProductID,
        consumptionDataReqdForIBDGRN: lotAllocationRes?.consumptionDataReqdForIBDGRN,
        allocationOwnedBySponsor: lotAllocationRes?.allocationOwnedBySponsor,
        batchAllocationPDFNotificationReqd: lotAllocationRes?.batchAllocationPDFNotificationReqd,
        batchAllocationPDFNotificationSubject: lotAllocationRes?.batchAllocationPDFNotificationSubject,
        batchAllocationPDFNotificationObjective: lotAllocationRes?.batchAllocationPDFNotificationObjective,
        vendorMosymphonyID: lotAllocationRes?.vendorMosymphonyID,
        brandOwnerMosymphonyID: data?.scheduleLineDetails?.brandOwnerMosymphonyID,
        schrockenSLID: data?.scheduleLineDetails?.schrockenSLID,
        collaboratorTypeID,
        vendorPlant: data?.scheduleLineDetails?.vendorPlant,
        storageLocation: data?.scheduleLineDetails?.storageLocation,
        fgMaterialCode: data?.scheduleLineDetails?.fgMaterialCode,
        fgMaterialName: data?.scheduleLineDetails?.fgMaterialName,
        sponsorName: data?.scheduleLineDetails?.sponsorName,
        vendorName: data?.scheduleLineDetails?.vendorName,
        documentID: documentId ? documentId.trim() : "",
        initialApprovalWorkflowSetup: isInitialSetup,
        approvalWorkflowDetails: approvalWorkflowDetails,
        approvalNotReqd: false,
        cc: ccList,
        poNumber: data?.scheduleLineDetails?.scheduleAgreementNumber,
        brand: data?.scheduleLineDetails?.brand,
        bomCode: bomCode && includeBomCode ? bomCode.trim() : "",
        artworkCode: artworkCode && includeArtworkCode ? artworkCode.trim() : "",
        generateAllocationPDF: true,
        componentAllocationDataList: lotAllocationRes?.componentAllocationDataList?.map(component => ({
          componentAllocationDetails: {
            componentCode: component?.componentAllocationDetails?.componentCode,
            componentName: component?.componentAllocationDetails?.componentName,
            componentQuantity: component?.componentAllocationDetails?.componentQuantity,
            uom: component?.componentAllocationDetails?.uom,
            lastUpdatedDate: component?.componentAllocationDetails?.lastUpdatedDate,
            deliveryScheduleLineCounter: component?.componentAllocationDetails?.deliveryScheduleLineCounter,
            cmoComponentCode: component?.componentAllocationDetails?.cmoComponentCode,
            cmoComponentName: component?.componentAllocationDetails?.cmoComponentName,
            cmoUOM: component?.componentAllocationDetails?.cmoUOM,
            boUOM: component?.componentAllocationDetails?.boUOM,
            plannedLotNumbers: component?.componentAllocationDetails?.plannedLotNumbers,
            countryOfOrigin: component?.componentAllocationDetails?.countryOfOrigin,
          },
          lotNumberAllocationDetails: component?.lotNumberAllocationDetails?.map(lot => ({
            lotNumber: lot?.lotNumber,
            plannedAllocatedQuantity: lot?.plannedAllocatedQuantity,
            expiryDate: lot?.expiryDate,
            netAvailableQuantity: lot?.netAvailableQuantity,
            dispatchDate: lot?.dispatchDate,
            manufacturingStartDate: lot?.manufacturingStartDate,
            lotReceiptDate: lot?.lotReceiptDate,
            allowMultipleLotAllocation: lot?.allowMultipleLotAllocation,
            allowOverAllocation: lot?.allowOverAllocation,
            overAllocationLimit: lot?.overAllocationLimit,
            cmoLotNumber: lot?.cmoLotNumber,
            boLotNumber: lot?.boLotNumber,
            boPlannedAllocatedQuantity: lot?.boPlannedAllocatedQuantity,
            lastUpdatedDate: lot?.lastUpdatedDate,
            //isDepletedBatch: lot?.isDepletedBatch || false,
          })) || [],
          inventoryDetails: component?.inventoryDetails?.map(inv => ({
            inventoryBatchNumber: inv?.inventoryBatchNumber,
            inventoryExpiryDate: inv?.inventoryExpiryDate,
            netAvailableQuantity: inv?.netAvailableQuantity,
            batchNearExpiry: inv?.batchNearExpiry,
          })) || [],
        })) || [],
      };
    
      
      // Call middleware API
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/processBatchAllocationApprovals`;
      
      const response = await axios.post(url, payload);
      
      if (response.data.status) {
        // Close workflow dialog and show success
        // Fetch updated data once (retry logic removed)
        await fetchLotAllocationData();
        setSavingWorkflow(false);
        setWorkflowDialogOpen(false);
        setPdfFieldValidationError("");
        setDocumentId("");
        setBomCode("");
        setArtworkCode("");
        setShareSuccessDialogOpen(true);
      } else {
        // Handle error
        console.error("Failed to process batch allocation approvals:", response.data);
        setSavingWorkflow(false);
        setSaveFailed(true);
      }
    } catch (error) {
      console.error("Error saving workflow:", error);
      setSavingWorkflow(false);
      setSaveFailed(true);
    }
  };

  // Function to handle PDF download from API response base64 data
  const handleDownloadPdfFromBase64 = () => {
    if (!lotAllocationRes?.pdfBase64) {
      console.error('No PDF base64 data available');
      return;
    }

    const fullPoNumber = data?.scheduleLineDetails?.scheduleAgreementNumber || '';
    const productCode = data?.scheduleLineDetails?.fgMaterialCode || '';
    
    // Extract latest lastUpdatedDate from lotNumberAllocationDetails across all components
    let latestDate = '';
    if (lotAllocationRes?.componentAllocationDataList && lotAllocationRes.componentAllocationDataList.length > 0) {
      const allDates = [];
      
      // Iterate through all components
      lotAllocationRes.componentAllocationDataList.forEach(component => {
        // Get dates from lotNumberAllocationDetails
        if (component?.lotNumberAllocationDetails && component.lotNumberAllocationDetails.length > 0) {
          component.lotNumberAllocationDetails.forEach(lot => {
            if (lot?.lastUpdatedDate) {
              allDates.push(lot.lastUpdatedDate);
            }
          });
        }
      });
      
      // Sort dates and get the latest one
      if (allDates.length > 0) {
        const sortedDates = allDates.sort().reverse();
        latestDate = new Date(sortedDates[0]).toISOString().split('T')[0]; // Format as YYYY-MM-DD
      }
    }
    
    const fileName = latestDate 
      ? `PO_${fullPoNumber}_Batch Allocation_${latestDate}.pdf`
      : `PO_${fullPoNumber}_Batch Allocation.pdf`;
    
    downloadPdfFromBase64(lotAllocationRes.pdfBase64, fileName);
  };

  // Drag and drop handlers
  const [draggedItem, setDraggedItem] = useState(null);

  const handleDragStart = (e, index) => {
    setDraggedItem(index);
    e.dataTransfer.effectAllowed = "move";
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    if (draggedItem === null || draggedItem === index) return;
    
    const newApprovers = [...approvers];
    const draggedApprover = newApprovers[draggedItem];
    newApprovers.splice(draggedItem, 1);
    newApprovers.splice(index, 0, draggedApprover);
    
    setApprovers(newApprovers);
    setDraggedItem(index);
  };

  const handleDragEnd = () => {
    setDraggedItem(null);
  };

  // Check if current user can approve allocation
  const canUserApprove = () => {
    if (!lotAllocationRes?.approvalWorkflowDetails || lotAllocationRes.approvalWorkflowDetails.length === 0) {
      return false;
    }

    const userEmail = tokenData?.email_address || "";
    
    // Find current user's approval entry
    const userApproval = lotAllocationRes.approvalWorkflowDetails.find(
      (approval) => approval.decisionBy === userEmail && approval.enableApprovalFlag === true
    );

    if (!userApproval) {
      return false;
    }

    // Check if user has already made a decision (approved or rejected)
    if (userApproval.decision !== null && userApproval.decision !== undefined) {
      return false; // User has already approved or rejected, don't show buttons
    }

    // Check if all previous approvals (lower sequence numbers) are completed
    const previousApprovals = lotAllocationRes.approvalWorkflowDetails.filter(
      (approval) => approval.sequenceNumber < userApproval.sequenceNumber
    );

    const allPreviousApproved = previousApprovals.every(
      (approval) => approval.decision === "Approved"
    );

    return allPreviousApproved;
  };

  // Handle approve/reject button click (opens electronic signature dialog)
  const handleApproveRejectAllocation = (decision) => {
    setElectronicSignatureDialog({
      open: true,
      decision: decision, // "Approve" or "Reject"
    });
  };

  // Close electronic signature dialog
  const handleCloseElectronicSignature = () => {
    setElectronicSignatureDialog({
      open: false,
      decision: "",
    });
  };

  // Handle electronic signature success
  const handleElectronicSignatureSuccess = async (status, comments = '') => {
    const decision = electronicSignatureDialog.decision;
    // Set flag to prevent useEffect from interfering
    setIsProcessingApproval(true);
    
    try {
      // Update approval workflow details
      const updatedApprovalWorkflow = lotAllocationRes.approvalWorkflowDetails.map((approval) => {
        if (approval.decisionBy === tokenData?.email_address && approval.enableApprovalFlag === true) {
          return {
            ...approval,
            decision: decision === "Approve" ? "Approved" : "Rejected",
            decisionDate: new Date().toISOString(),
            remarks: comments || '',
            enableApprovalFlag: false,
          };
        }
        return approval;
      });

      // Build request payload
      const payload = {
        batchAllocationSentForApprovalBy:lotAllocationRes?.batchAllocationSentForApprovalBy,
        batchAllocationSentForApprovalDate:lotAllocationRes?.batchAllocationSentForApprovalDate,
        boProductCode: lotAllocationRes?.boProductCode,
        cmoProductCode: lotAllocationRes?.cmoProductCode,
        boProductDescription: lotAllocationRes?.boProductDescription,
        cmoProductDescription: lotAllocationRes?.cmoProductDescription,
        collabrixProductID: lotAllocationRes?.collabrixProductID,
        consumptionDataReqdForIBDGRN: lotAllocationRes?.consumptionDataReqdForIBDGRN,
        allocationOwnedBySponsor: lotAllocationRes?.allocationOwnedBySponsor,
        batchAllocationPDFNotificationReqd: lotAllocationRes?.batchAllocationPDFNotificationReqd,
        batchAllocationPDFNotificationSubject: lotAllocationRes?.batchAllocationPDFNotificationSubject,
        batchAllocationPDFNotificationObjective: lotAllocationRes?.batchAllocationPDFNotificationObjective,
        vendorMosymphonyID: lotAllocationRes?.vendorMosymphonyID,
        artworkCode: lotAllocationRes?.artworkCode,
        bomCode: lotAllocationRes?.bomCode,
        brandOwnerMosymphonyID: data?.scheduleLineDetails?.brandOwnerMosymphonyID,
        schrockenSLID: data?.scheduleLineDetails?.schrockenSLID,
        collaboratorTypeID,
        vendorPlant: data?.scheduleLineDetails?.vendorPlant,
        storageLocation: data?.scheduleLineDetails?.storageLocation,
        fgMaterialCode: data?.scheduleLineDetails?.fgMaterialCode,
        fgMaterialName: data?.scheduleLineDetails?.fgMaterialName,
        sponsorName: data?.scheduleLineDetails?.sponsorName,
        vendorName: data?.scheduleLineDetails?.vendorName,
        poNumber: data?.scheduleLineDetails?.scheduleAgreementNumber,
        brand: data?.scheduleLineDetails?.brand,
        approvalNotReqd: false,
        allocationApproved: decision === "Approve",
        approvalWorkflowDetails: updatedApprovalWorkflow,
        generateAllocationPDF: decision === "Approve" ? lotAllocationRes?.generateAllocationPDF : false,
        componentAllocationDataList: lotAllocationRes?.componentAllocationDataList?.map(component => ({
          componentAllocationDetails: {
            componentCode: component?.componentAllocationDetails?.componentCode,
            componentName: component?.componentAllocationDetails?.componentName,
            componentQuantity: component?.componentAllocationDetails?.componentQuantity,
            uom: component?.componentAllocationDetails?.uom,
            lastUpdatedDate: component?.componentAllocationDetails?.lastUpdatedDate,
            deliveryScheduleLineCounter: component?.componentAllocationDetails?.deliveryScheduleLineCounter,
            cmoComponentCode: component?.componentAllocationDetails?.cmoComponentCode,
            cmoComponentName: component?.componentAllocationDetails?.cmoComponentName,
            cmoUOM: component?.componentAllocationDetails?.cmoUOM,
            boUOM: component?.componentAllocationDetails?.boUOM,
            plannedLotNumbers: component?.componentAllocationDetails?.plannedLotNumbers,
            countryOfOrigin: component?.componentAllocationDetails?.countryOfOrigin,
          },
          lotNumberAllocationDetails: component?.lotNumberAllocationDetails?.map(lot => ({
            lotNumber: lot?.lotNumber,
            plannedAllocatedQuantity: lot?.plannedAllocatedQuantity,
            expiryDate: lot?.expiryDate,
            netAvailableQuantity: lot?.netAvailableQuantity,
            dispatchDate: lot?.dispatchDate,
            manufacturingStartDate: lot?.manufacturingStartDate,
            lotReceiptDate: lot?.lotReceiptDate,
            allowMultipleLotAllocation: lot?.allowMultipleLotAllocation,
            allowOverAllocation: lot?.allowOverAllocation,
            overAllocationLimit: lot?.overAllocationLimit,
            cmoLotNumber: lot?.cmoLotNumber,
            boLotNumber: lot?.boLotNumber,
            boPlannedAllocatedQuantity: lot?.boPlannedAllocatedQuantity,
            lastUpdatedDate: lot?.lastUpdatedDate,
           // isDepletedBatch: lot?.isDepletedBatch || false,
          })) || [],
          inventoryDetails: component?.inventoryDetails?.map(inv => ({
            inventoryBatchNumber: inv?.inventoryBatchNumber,
            inventoryExpiryDate: inv?.inventoryExpiryDate,
            netAvailableQuantity: inv?.netAvailableQuantity,
            batchNearExpiry: inv?.batchNearExpiry,
          })) || [],
        })) || [],
      };

  


      // Call middleware API
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/processBatchAllocationApprovals`;
      
      const response = await axios.post(url, payload);

      if (response.data.status) {
        // Close electronic signature dialog
        setElectronicSignatureDialog({
          open: false,
          decision: "",
        });
        
        // Show success message
        // Note: setIsProcessingApproval(false) will be called when OK button is clicked
        setApproveRejectSuccess({
          open: true,
          type: decision,
        });
      } else {
        console.error("Failed to process approval:", response.data);
        setSaveFailed(true);
        // Reset flag on error
        setIsProcessingApproval(false);
      }
    } catch (error) {
      console.error("Error processing approval:", error);
      setSaveFailed(true);
      // Reset flag on error
      setIsProcessingApproval(false);
    }
  };

  // Function to generate approval workflow note message
  const generateApprovalNote = () => {
    if (!lotAllocationRes?.approvalWorkflowDetails || lotAllocationRes.approvalWorkflowDetails.length === 0) {
      return null;
    }

    const approvalWorkflow = lotAllocationRes.approvalWorkflowDetails;
    const sentBy = lotAllocationRes?.sentForApprovalBy || null;
    const sentForApprovalTo = lotAllocationRes?.sentForApprovalTo || null;
    const approvedByApproverNames = lotAllocationRes?.approvedByApproverNames || [];
    

    
    // Filter approvers with enableApprovalFlag = true (pending approvals)
    const pendingApprovers = approvalWorkflow.filter(item => item.enableApprovalFlag === true && !item.decision);
    
    // Filter approvers who have already taken action (approved/rejected)
    const completedApprovers = approvalWorkflow.filter(item => item.decision || item.enableApprovalFlag === false);
    
    // Sort by sequence number to maintain order
    const sortedPending = [...pendingApprovers].sort((a, b) => a.sequenceNumber - b.sequenceNumber);
    const sortedCompleted = [...completedApprovers].sort((a, b) => a.sequenceNumber - b.sequenceNumber);
    
    let message = "";
    
    // Case 1: All approvals done
    if (pendingApprovers.length === 0 && completedApprovers.length > 0) {
      // Use approvedByApproverNames if available, otherwise fallback to decisionBy
      const approverNames = approvedByApproverNames.length > 0 
        ? approvedByApproverNames.map(name => `'${name}'`).join(" and ")
        : sortedCompleted.map(item => `'${item.decisionBy}'`).join(" and ");
      message = `Component allocation approved by ${approverNames}.`;
    }
    // Case 2: Some approvals done, some pending
    else if (completedApprovers.length > 0 && pendingApprovers.length > 0) {
      // Use approvedByApproverNames for completed approvals
      const completedNames = approvedByApproverNames.length > 0 
        ? approvedByApproverNames.map(name => `'${name}'`).join(" and ")
        : sortedCompleted.map(item => `'${item.decisionBy}'`).join(" and ");
      // Use sentForApprovalTo for next pending approver
      const nextApproverName = sentForApprovalTo || sortedPending[0]?.decisionBy;
      message = `Component allocation approved by ${completedNames} and sent for approval to '${nextApproverName}' by ${sentBy}.`;
    }
    // Case 3: Initial state - sent for approval to first approver
    else if (completedApprovers.length === 0 && pendingApprovers.length > 0) {
      // Use sentForApprovalTo for the first pending approver
      const firstApproverName = sentForApprovalTo || sortedPending[0]?.decisionBy;
      message = `Component allocation sent for approval to '${firstApproverName}' by ${sentBy}.`;
    }
    
    return message;
  };

  const approvalNote = generateApprovalNote();

  // Function to check if all approvals are complete
  const areAllApprovalsComplete = () => {
    // If no approval workflow exists or it's empty, check if pdfBase64 exists
    if (!lotAllocationRes?.approvalWorkflowDetails || lotAllocationRes.approvalWorkflowDetails.length === 0) {
      // Enable download if pdfBase64 exists when approval workflow is empty
      return !!lotAllocationRes?.pdfBase64;
    }

    const approvalWorkflow = lotAllocationRes.approvalWorkflowDetails;
    
    // Check if all approvers have approved
    const allApproved = approvalWorkflow.every(item => item.decision === "Approved");
    return allApproved;
  };

  // Function to check if approval workflow has any rejection
  const hasApprovalRejection = () => {
    if (!lotAllocationRes?.approvalWorkflowDetails || lotAllocationRes.approvalWorkflowDetails.length === 0) {
      return false;
    }
    return lotAllocationRes.approvalWorkflowDetails.some(item => item.decision === "Rejected");
  };

  // Function to check if approval workflow exists
  const hasApprovalWorkflow = () => {
    return lotAllocationRes?.approvalWorkflowDetails && lotAllocationRes.approvalWorkflowDetails.length > 0;
  };

  // Function to check if any approver has enableApprovalFlag set to true
  const hasEnabledApprovalFlag = () => {
    if (!lotAllocationRes?.approvalWorkflowDetails || lotAllocationRes.approvalWorkflowDetails.length === 0) {
      return false;
    }
    return lotAllocationRes.approvalWorkflowDetails.some(approver => approver.enableApprovalFlag === true);
  };



  // const handleConfirmAllocation = async (lotNumber, lot, data) => {
  //   try {
  //     const schrockenSLID = data?.scheduleLineDetails?.schrockenSLID;
  //     const cdmoOrgID = data?.scheduleLineDetails?.vendorMosymphonyID;

  //     const selectedLotDetails = lot.lotNumberAllocationDetails.find(lotItem => lotItem.lotNumber === lotNumber);

  //     if (!selectedLotDetails) {
  //       console.error("Lot number not found in allocation details.");
  //       return;
  //     }

  //     const requestData = {
  //       schrockenSLID,
  //       cdmoOrgID,
  //       dateChangeFlag: false,
  //       componentAllocationDataList: [
  //         {
  //           componentAllocationDetails: {
  //             componentCode: lot.componentAllocationDetails.componentCode,
  //             deliveryScheduleLineCounter: lot.componentAllocationDetails.deliveryScheduleLineCounter,
  //           },
  //           previousLotNumberAllocationDetails: [],
  //           lotNumberAllocationDetails: [
  //             {
  //               lotNumber: selectedLotDetails.lotNumber,
  //               plannedAllocatedQuantity: selectedLotDetails.plannedAllocatedQuantity,
  //             },
  //           ],
  //         },
  //       ],
  //     };

  //     const apiUrl = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateComponentAllocationNew`;

  //     await axios.post(apiUrl, requestData);

  //   } catch (error) {
  //     console.error("Error in handleConfirmAllocation:", error);
  //   }
  // };



  return (
    <React.Fragment>
      {data?.batchDetails &&
      data?.batchDetails?.bomConsumptionAddedIndicator ? (
        <ViewRmPmLotTable
          apiData={lotAllocationData}
          loading={tableLoading}
          error={error}
          batchDetails={data?.batchDetails}
        />
      ) : (
        <>
          
          <TableContainer
            style={{ marginTop: "1rem", minHeight: "auto", maxHeight: "400px" }}
            component={Paper}
            className={classes.tableContainer}
          >
          <Table stickyHeader className="default-table-styles">
            {/* Table Head */}
            <TableHead>
              {/* Main header row */}
              <TableRow style={{ width: "100%" }}>
                <TableCell
                  style={{ width: "23%", minWidth: "170px" }}
                  align="left"
                  className={classes.headerCell}
                >
                  BMS Material Code / Description
                </TableCell>
                <TableCell
                  style={{ width: "11%" }}
                  align="right"
                  className={classes.headerCell}
                >
                  Material BoM Qty.
                </TableCell>
                <TableCell
                  style={{ width: "11%", paddingLeft: "3%" }}
                  align="left"
                  className={classes.headerCell}
                >
                  UoM
                </TableCell>
                <TableCell
                  style={{ width: "11%", whiteSpace: "nowrap" }}
                  align="left"
                  className={classes.headerCell}
                >
                  BMS Material Batch Number
                </TableCell>
                <TableCell
                  style={{ width: "11%", minWidth: "92px" }}
                  align="right"
                  className={classes.headerCell}
                >
                  Net Available Qty.
                </TableCell>
                <TableCell
                  style={{ width: "16%", paddingLeft: "3%", minWidth: "110px" }}
                  align="left"
                  className={classes.headerCell}
                >
                  Expiry Date
                </TableCell>
                <TableCell
                  style={{ width: "16%", whiteSpace: "nowrap" }}
                  align="right"
                  className={classes.headerCell}
                >
                  Planned Allocated Qty.
                </TableCell>
                <TableCell
                  style={{ width: "11%", minWidth: "130px" }}
                  align="left"
                  className={classes.headerCell}
                >
                  Planned Material Batch Number
                  <IconButton
                    size="small"
                    onClick={() => setInfoDialogOpen(true)}
                    style={{ marginLeft: "4px", padding: "4px" }}
                  >
                    <InfoOutlinedIcon
                      style={{ fontSize: "18px", color: "#666" }}
                    />
                  </IconButton>
                </TableCell>
                <TableCell
                  style={{ width: "11%", minWidth: "100px" }}
                  align="left"
                  className={classes.headerCell}
                >
                  Country of Origin
                </TableCell>
                {/* <TableCell className={classes.headerCell}>
                RM/PM lot MFG start date
              </TableCell>
              <TableCell className={classes.headerCell}>
                RM/PM lot MFG dispatch date
              </TableCell>
              <TableCell className={classes.headerCell}>
                RM/PM lot MFG receipt date
              </TableCell> */}
              </TableRow>
            </TableHead>
            {/* Table Body */}
            {tableLoading ? (
              <TableBody>
                <TableRow>
                  <TableCell colSpan={9}>
                    <div style={{ textAlign: "center" }}>
                      <CircularProgress color="primary" thickness={7} />
                    </div>
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : error ? (
              <TableBody>
                <TableRow
                  style={{
                    border: "2px solid rgb(255,0,0)",
                    backgroundColor: "rgb(255,240,240)",
                    Opacity: 1,
                    textAlign: "center",
                    padding: "0.8rem",
                    fontSize: "0.875rem",
                  }}
                >
                  <TableCell
                    style={{ padding: "10px" }}
                    colSpan={9}
                    align="center"
                  >
                    Something went wrong. Please try again later.
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <TableBody>
                {/* 
                  Table rendering logic:
                  1. If lotNumberAllocationDetails has data -> show lot allocation rows
                  2. If inventoryDetails has data (length > 0 and < 4) -> show inventory rows  
                  3. Else -> show component data with "NA" values (fallback case)
                  
                  Note: Previously, the condition was just "inventoryDetails.length < 4" which 
                  caused empty arrays to trigger inventory mapping but render nothing.
                  Fixed to check "length > 0 AND length < 4" so empty arrays fall through 
                  to the component data display case.
                */}
                {lotAllocationData?.length > 0 ? (
                  lotAllocationData.map((component, index) => (
                    <React.Fragment key={index}>
                      {/* Case 1: Display lot allocation data if available */}
                      {component?.lotNumberAllocationDetails.length > 0 ? (
                        component?.lotNumberAllocationDetails.map(
                          (lot, lotIndex) => (
                            <TableRow style={{ width: "100%" }} key={lotIndex}>
                              {lotIndex === 0 && (
                                <TableCell
                                  style={{ width: "23%" }}
                                  align="left"
                                  rowSpan={
                                    component.lotNumberAllocationDetails.length
                                  }
                                >
                                  <div>
                                    {presentFormatedData(
                                      component?.componentAllocationDetails
                                        ?.componentCode,
                                      "NA"
                                    )}{" "}
                                    {"/"}
                                  </div>
                                  <div>
                                    {presentFormatedData(
                                      component?.componentAllocationDetails
                                        ?.componentName,
                                      "NA"
                                    )}
                                  </div>
                                </TableCell>
                              )}

                              {lotIndex === 0 && (
                                <TableCell
                                  style={{ width: "11%" }}
                                  align="right"
                                  rowSpan={
                                    component.lotNumberAllocationDetails.length
                                  }
                                >
                                  {component?.componentAllocationDetails
                                    ?.componentQuantity !== undefined &&
                                  component?.componentAllocationDetails
                                    ?.componentQuantity !== null
                                    ? Number(
                                        component?.componentAllocationDetails
                                          ?.componentQuantity
                                      ).toFixed(3)
                                    : "NA"}
                                </TableCell>
                              )}

                              {lotIndex === 0 && (
                                <TableCell
                                  style={{ width: "11%", paddingLeft: "3%" }}
                                  align="left"
                                  rowSpan={
                                    component.lotNumberAllocationDetails.length
                                  }
                                >
                                  {presentFormatedData(
                                    component?.componentAllocationDetails?.uom,
                                    "NA"
                                  )}
                                </TableCell>
                              )}

                              {/* Lot-Specific Data */}
                              <TableCell
                                style={{ width: "11%", whiteSpace: "nowrap" }}
                                align="left"
                              >
                                {lot?.lotNumber || "NA"}
                              </TableCell>
                              {/* Check if netAvailableQuantity exists before displaying */}
                              <TableCell style={{ width: "11%" }} align="right">
                                {lot?.netAvailableQuantity
                                  ? presentFormatedData(
                                      lot?.netAvailableQuantity
                                    )
                                  : "NA"}
                              </TableCell>
                              <TableCell
                                style={{ width: "16%", paddingLeft: "3%" }}
                                align="left"
                              >
                                {dateFormated(
                                  lot?.expiryDate,
                                  "DD-MMM-YYYY",
                                  "NA"
                                ).toUpperCase()}
                              </TableCell>

                              {/* <TableCell style={{width:"16%",whiteSpace:"nowrap"}} align="right">
                                {lot?.plannedAllocatedQuantity} */}
                              {/* {(localStorage.collabType !== "CMO" && lotIndex ===
                                  component.lotNumberAllocationDetails.length -
                                  1) && (
                                    // lot.defaultAllocation ? (
                                    //   <IconButton onClick={() => handleConfirmAllocation(lot.lotNumber, component, data)}>
                                    //     <CheckCircleOutlineIcon style={{ fontSize: "large", color: "#28a745" }} />
                                    //   </IconButton>
                                    // ) : (
                                    //   <IconButton onClick={() => handleOpenDialog(component, component?.componentAllocationDetails?.componentCode)}>
                                    //     <EditIcon style={{ fontSize: "large", color: "#000000" }} />
                                    //   </IconButton>
                                    // )
                                    <IconButton onClick={() => handleOpenDialog(component, component?.componentAllocationDetails?.componentCode)}>
                                      <EditIcon style={{ fontSize: "large", color: "#000000" }} />
                                    </IconButton>
                                  )} */}

                              {/* {showPencilButton &&
                                  localStorage.collabType !== "CMO" &&
                                  featuresAccess?.editPlannedAllocatedQty &&
                                  //&& data?.scheduleLineDetails?.plannerEmailID ===decoded.email_address
                                  lotIndex ===
                                    component.lotNumberAllocationDetails
                                      .length -
                                      1 && (
                                    <IconButton
                                      onClick={() =>
                                        handleOpenDialog(
                                          component,
                                          component?.componentAllocationDetails
                                            ?.componentCode
                                        )
                                        }
                                      >
                                        <EditIcon
                                          fontSize="large"
                                          style={{
                                            color: "#ec6535",
                                          }}
                                        />
                                      </IconButton>
                                )}
                                      {data?.scheduleLineDetails?.editLotAllocationTab === true && (
                                      <IconButton onClick={() => handleOpenDialog(component, component?.componentAllocationDetails?.componentCode)}>
                                        <EditIcon
                                          fontSize="large"
                                          style={{
                                            color:
                                              component.lotNumberAllocationDetails.length > 0
                                                ? "#ec6535"
                                                : "#e36e39",
                                          }}
                                        />
                                      </IconButton>
                                    )} */}

                              {/* <EditPlannedAllocatedQuantity
                                inventoryDetails={component.inventoryDetails}
                                initialValue={lot?.plannedAllocatedQuantity}
                              /> */}
                              {/* </TableCell> */}

                              <TableCell>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "flex-end",
                                    gap: "8px",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      minWidth: "40px",
                                      justifyContent: "flex-end",
                                    }}
                                  >
                                    {lot?.plannedAllocatedQuantity ?? "NA"}
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "4px",
                                      alignItems: "center",
                                    }}
                                  >
                                    {
                                      <>
                                        {(() => {
                                          const allocatedQty =
                                            localStorage.collabType === "CMO"
                                              ? lot?.boPlannedAllocatedQuantity
                                              : lot?.plannedAllocatedQuantity;
                                          const isNA =
                                            allocatedQty === null ||
                                            allocatedQty === undefined ||
                                            allocatedQty === "" ||
                                            allocatedQty === "NA" ||
                                            Number(allocatedQty) === 0;
                                          return (
                                            <IconButton
                                              onClick={() =>
                                                handleOpenDialog(
                                                  component,
                                                  component
                                                    ?.componentAllocationDetails
                                                    ?.componentCode
                                                )
                                              }
                                              disabled={!canEditFields}
                                              className={classes.editIconButton}
                                              size="small"
                                            >
                                              <EditIcon
                                                fontSize={
                                                  isNA ? "large" : "small"
                                                }
                                                style={{
                                                  color: "#ec6535",
                                                }}
                                              />
                                            </IconButton>
                                          );
                                        })()}
                                        {/* Show delete icon only if there's an allocated quantity */}
                                        {(() => {
                                          const allocatedQty =
                                            localStorage.collabType === "CMO"
                                              ? lot?.boPlannedAllocatedQuantity
                                              : lot?.plannedAllocatedQuantity;
                                          const hasAllocatedQty =
                                            allocatedQty !== null &&
                                            allocatedQty !== undefined &&
                                            allocatedQty !== "" &&
                                            allocatedQty !== "NA" &&
                                            Number(allocatedQty) > 0;
                                          return hasAllocatedQty ? (
                                            <IconButton
                                              onClick={() =>
                                                handleOpenDeleteDialog(
                                                  lot,
                                                  component
                                                )
                                              }
                                              disabled={!canEditFields}
                                              className={classes.editIconButton}
                                              size="small"
                                              //style={{ padding: "4px", width: "28px", height: "28px" }}
                                            >
                                              <DeleteIcon
                                                fontSize="small"
                                                style={{
                                                  color: "#ec6535",
                                                }}
                                              />
                                            </IconButton>
                                          ) : null;
                                        })()}
                                      </>
                                    }
                                  </div>
                                </div>
                              </TableCell>

                              {lotIndex === 0 && (
                                <TableCell
                                  style={{ width: "11%" }}
                                  align="left"
                                  rowSpan={
                                    component.lotNumberAllocationDetails.length
                                  }
                                >
                                  {editingBatchRow ===
                                  `${component?.componentAllocationDetails?.componentCode}-${index}` ? (
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "flex-start",
                                        gap: "4px",
                                      }}
                                    >
                                      <TextField
                                        placeholder="164859141N, 164859142N"
                                        value={plannedBatchNumber}
                                        onChange={
                                          handlePlannedBatchNumberChange
                                        }
                                        onBlur={handlePlannedBatchNumberBlur}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        multiline
                                        minRows={1}
                                        InputProps={{
                                          style: {
                                            fontSize: "14px",
                                            lineHeight: "1.4",
                                            padding: "8px 12px",
                                          },
                                        }}
                                        style={{ backgroundColor: "#fff" }}
                                      />
                                      <Box
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: "3px",
                                        }}
                                      >
                                        <span title="save">
                                          <SaveIcon
                                            onClick={
                                              plannedBatchNumber.trim() ||
                                              component
                                                ?.componentAllocationDetails
                                                ?.plannedLotNumbers
                                                ? handleSavePlannedBatch
                                                : undefined
                                            }
                                            style={{
                                              cursor: "pointer",
                                              fontSize: "small",
                                            }}
                                          />
                                        </span>
                                        <span title="clear">
                                          <ClearIcon
                                            onClick={handleCancelEdit}
                                            style={{
                                              cursor: "pointer",
                                              fontSize: "small",
                                            }}
                                          />
                                        </span>
                                      </Box>
                                    </div>
                                  ) : (
                                    <>
                                      {presentFormatedData(
                                        component?.componentAllocationDetails
                                          ?.plannedLotNumbers,
                                        "NA"
                                      )}
                                      {canEditFields &&
                                        localStorage.getItem("collabType") !==
                                          "CMO" && (
                                          <IconButton
                                            onClick={() =>
                                              handleOpenPlannedBatchDialog(
                                                lot,
                                                component,
                                                index
                                              )
                                            }
                                            size="small"
                                          >
                                            <EditIcon
                                              fontSize="large"
                                              style={{ color: "#ec6535" }}
                                            />
                                          </IconButton>
                                        )}
                                    </>
                                  )}
                                </TableCell>
                              )}
                              {lotIndex === 0 && (
                                <TableCell
                                  style={{ width: "11%", minWidth: "100px" }}
                                  align="left"
                                  rowSpan={
                                    component.lotNumberAllocationDetails.length
                                  }
                                >
                                  {editingCountryRow ===
                                  `${component?.componentAllocationDetails?.componentCode}-${index}` ? (
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "flex-start",
                                        gap: "4px",
                                      }}
                                    >
                                      <TextField
                                        placeholder="Enter Country"
                                        value={countryOfOrigin}
                                        onChange={handleCountryOfOriginChange}
                                        onBlur={handleCountryOfOriginBlur}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        multiline
                                        minRows={1}
                                        InputProps={{
                                          style: {
                                            fontSize: "14px",
                                            lineHeight: "1.4",
                                            // padding: '8px 12px'
                                          },
                                        }}
                                        style={{ backgroundColor: "#fff" }}
                                      />
                                      <Box
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: "3px",
                                        }}
                                      >
                                        <span title="save">
                                          <SaveIcon
                                            onClick={
                                              countryOfOrigin.trim() ||
                                              component
                                                ?.componentAllocationDetails
                                                ?.countryOfOrigin
                                                ? () =>
                                                    handleSaveCountry(component)
                                                : undefined
                                            }
                                            style={{
                                              cursor: "pointer",
                                              fontSize: "small",
                                            }}
                                          />
                                        </span>
                                        <span title="clear">
                                          <ClearIcon
                                            onClick={handleCancelCountryEdit}
                                            style={{
                                              cursor: "pointer",
                                              fontSize: "small",
                                            }}
                                          />
                                        </span>
                                      </Box>
                                    </div>
                                  ) : (
                                    <>
                                      {presentFormatedData(
                                        component?.componentAllocationDetails
                                          ?.countryOfOrigin,
                                        "NA"
                                      )}
                                      {canEditFields &&
                                        localStorage.getItem("collabType") !==
                                          "CMO" && (
                                          <IconButton
                                            onClick={() =>
                                              handleEditCountryClick(
                                                component,
                                                index
                                              )
                                            }
                                            size="small"
                                          >
                                            <EditIcon
                                              fontSize="large"
                                              style={{ color: "#ec6535" }}
                                            />
                                          </IconButton>
                                        )}
                                    </>
                                  )}
                                </TableCell>
                              )}
                              {/* <TableCell style={{whiteSpace:'nowrap'}}>
                              <EditRmPmLotMfgStartDate
                                lotAllocationData={lot}
                                componentDetails = {component}
                                mfgStartDate={lot?.manufacturingStartDate}
                                schrockenSLID={
                                  data?.scheduleLineDetails?.schrockenSLID
                                }
                                vendorMosymphonyID={
                                  data?.scheduleLineDetails?.vendorMosymphonyID
                                }
                                handleClose={handleLotAllocationStatus}
                              />
                            </TableCell>
                            <TableCell style={{whiteSpace:'nowrap'}}>
                              <EditRmPmLotMfgDispatchDate
                                dispatchDate={lot?.dispatchDate}
                                lotAllocationData={lot}
                                componentDetails = {component}
                                schrockenSLID={
                                  data?.scheduleLineDetails?.schrockenSLID
                                }
                                vendorMosymphonyID={
                                  data?.scheduleLineDetails?.vendorMosymphonyID
                                }
                                handleClose={handleLotAllocationStatus}
                              />
                            </TableCell>
                            <TableCell style={{whiteSpace:'nowrap'}}>
                              <EditRmPmLotMfgReceiptDate
                                lotReceiptDate={lot?.lotReceiptDate}
                                lotAllocationData={lot}
                                componentDetails = {component}
                                schrockenSLID={
                                  data?.scheduleLineDetails?.schrockenSLID
                                }
                                vendorMosymphonyID={
                                  data?.scheduleLineDetails?.vendorMosymphonyID
                                }
                                handleClose={handleLotAllocationStatus}
                              />
                            </TableCell> */}
                            </TableRow>
                          )
                        )
                      ) : component?.inventoryDetails &&
                        component?.inventoryDetails.length < 4 ? (
                        // Case 2: Display inventory data if available (length > 0 and < 4)
                        component?.inventoryDetails.map((val, invIndex) => (
                          <TableRow style={{ width: "100%" }} key={invIndex}>
                            {invIndex === 0 && (
                              <TableCell
                                style={{ width: "23%" }}
                                align="left"
                                rowSpan={component?.inventoryDetails.length}
                              >
                                <div>
                                  {presentFormatedData(
                                    component?.componentAllocationDetails
                                      ?.componentCode,
                                    "NA"
                                  )}
                                  {"/"}
                                </div>
                                <div>
                                  {presentFormatedData(
                                    component?.componentAllocationDetails
                                      ?.componentName,
                                    "NA"
                                  )}
                                </div>
                              </TableCell>
                            )}

                            {invIndex === 0 && (
                              <TableCell
                                style={{ width: "11%" }}
                                align="right"
                                rowSpan={component?.inventoryDetails.length}
                              >
                                {component?.componentAllocationDetails
                                  ?.componentQuantity !== undefined &&
                                component?.componentAllocationDetails
                                  ?.componentQuantity !== null
                                  ? Number(
                                      component?.componentAllocationDetails
                                        ?.componentQuantity
                                    ).toFixed(3)
                                  : "NA"}
                              </TableCell>
                            )}

                            {invIndex === 0 && (
                              <TableCell
                                style={{ width: "11%", paddingLeft: "3%" }}
                                align="left"
                                rowSpan={component?.inventoryDetails.length}
                              >
                                {presentFormatedData(
                                  component?.componentAllocationDetails?.uom,
                                  "NA"
                                )}
                              </TableCell>
                            )}
                            {/* Lot-Specific Data */}
                            <TableCell
                              style={{ width: "11%", whiteSpace: "nowrap" }}
                              align="left"
                            >
                              {presentFormatedData(
                                val?.inventoryBatchNumber,
                                "NA"
                              )}
                            </TableCell>
                            {/* Check if netAvailableQuantity exists before displaying */}
                            <TableCell style={{ width: "11%" }} align="right">
                              {presentFormatedData(
                                val?.netAvailableQuantity,
                                "NA"
                              )}
                            </TableCell>
                            <TableCell
                              style={{ width: "16%", paddingLeft: "3%" }}
                              align="left"
                            >
                              {dateFormated(
                                val?.inventoryExpiryDate,
                                "DD-MMM-YYYY",
                                "NA"
                              ).toUpperCase()}
                            </TableCell>
                            <TableCell
                              style={{ width: "16%", whiteSpace: "nowrap" }}
                              align="right"
                            >
                              NA
                              {/* {showPencilButton &&
                                localStorage.collabType !== "CMO" &&
                                featuresAccess?.editPlannedAllocatedQty &&
                                //&& data?.scheduleLineDetails?.plannerEmailID ===decoded.email_address
                                index ===
                                  component?.inventoryDetails.length - 1 && (
                                  <IconButton
                                    onClick={() =>
                                      handleOpenDialog(
                                        component,
                                        component?.componentAllocationDetails
                                          ?.componentCode
                                      )
                                    }
                                  >
                                    <EditIcon
                                      style={{
                                        fontSize: "large",
                                        color: "red",
                                      }}
                                    />
                                  </IconButton>
                                )} */}
                              {
                                <IconButton
                                  onClick={() =>
                                    handleOpenPlannedQtyDialog(component)
                                  }
                                  disabled={!canEditFields}
                                  className={classes.editIconButton}
                                >
                                  <EditIcon
                                    fontSize="large"
                                    style={{
                                      color: "#ec6535",
                                    }}
                                  />
                                </IconButton>
                              }
                              {/* </div>
                              </div> */}
                            </TableCell>
                            {invIndex === 0 && (
                              <TableCell
                                style={{ width: "11%" }}
                                align="left"
                                rowSpan={component?.inventoryDetails.length}
                              >
                                {editingBatchRow ===
                                `${component?.componentAllocationDetails?.componentCode}-${index}` ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "flex-start",
                                      gap: "4px",
                                    }}
                                  >
                                    <TextField
                                      placeholder="164859141N, 164859142N"
                                      value={plannedBatchNumber}
                                      onChange={handlePlannedBatchNumberChange}
                                      onBlur={handlePlannedBatchNumberBlur}
                                      variant="outlined"
                                      size="small"
                                      fullWidth
                                      multiline
                                      minRows={1}
                                      InputProps={{
                                        style: {
                                          fontSize: "14px",
                                          lineHeight: "1.4",
                                          padding: "8px 12px",
                                        },
                                      }}
                                      style={{ backgroundColor: "#fff" }}
                                    />
                                    <Box
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "3px",
                                      }}
                                    >
                                      <span title="save">
                                        <SaveIcon
                                          onClick={
                                            plannedBatchNumber.trim() ||
                                            component
                                              ?.componentAllocationDetails
                                              ?.plannedLotNumbers
                                              ? handleSavePlannedBatch
                                              : undefined
                                          }
                                          style={{
                                            cursor: "pointer",
                                            fontSize: "small",
                                          }}
                                        />
                                      </span>
                                      <span title="clear">
                                        <ClearIcon
                                          onClick={handleCancelEdit}
                                          style={{
                                            cursor: "pointer",
                                            fontSize: "small",
                                          }}
                                        />
                                      </span>
                                    </Box>
                                  </div>
                                ) : (
                                  <>
                                    {presentFormatedData(
                                      component?.componentAllocationDetails
                                        ?.plannedLotNumbers,
                                      "NA"
                                    )}
                                    {canEditFields &&
                                      localStorage.getItem("collabType") !==
                                        "CMO" && (
                                        <IconButton
                                          onClick={() =>
                                            handleOpenPlannedBatchDialog(
                                              val,
                                              component,
                                              index
                                            )
                                          }
                                          size="small"
                                        >
                                          <EditIcon
                                            fontSize="large"
                                            style={{ color: "#ec6535" }}
                                          />
                                        </IconButton>
                                      )}
                                  </>
                                )}
                              </TableCell>
                            )}
                            {invIndex === 0 && (
                              <TableCell
                                style={{ width: "11%", minWidth: "100px" }}
                                align="left"
                                rowSpan={component?.inventoryDetails.length}
                              >
                                {editingCountryRow ===
                                `${component?.componentAllocationDetails?.componentCode}-${index}` ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "flex-start",
                                      gap: "4px",
                                    }}
                                  >
                                    <TextField
                                      placeholder="Enter Country"
                                      value={countryOfOrigin}
                                      onChange={handleCountryOfOriginChange}
                                      onBlur={handleCountryOfOriginBlur}
                                      variant="outlined"
                                      size="small"
                                      fullWidth
                                      multiline
                                      minRows={1}
                                      InputProps={{
                                        style: {
                                          fontSize: "14px",
                                          lineHeight: "1.4",
                                          // padding: '8px 12px'
                                        },
                                      }}
                                      style={{ backgroundColor: "#fff" }}
                                    />
                                    <Box
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "3px",
                                      }}
                                    >
                                      <span title="save">
                                        <SaveIcon
                                          onClick={
                                            countryOfOrigin.trim() ||
                                            component
                                              ?.componentAllocationDetails
                                              ?.countryOfOrigin
                                              ? () =>
                                                  handleSaveCountry(component)
                                              : undefined
                                          }
                                          style={{
                                            cursor: "pointer",
                                            fontSize: "small",
                                          }}
                                        />
                                      </span>
                                      <span title="clear">
                                        <ClearIcon
                                          onClick={handleCancelCountryEdit}
                                          style={{
                                            cursor: "pointer",
                                            fontSize: "small",
                                          }}
                                        />
                                      </span>
                                    </Box>
                                  </div>
                                ) : (
                                  <>
                                    {presentFormatedData(
                                      component?.componentAllocationDetails
                                        ?.countryOfOrigin,
                                      "NA"
                                    )}
                                    {canEditFields &&
                                      localStorage.getItem("collabType") !==
                                        "CMO" && (
                                        <IconButton
                                          onClick={() =>
                                            handleEditCountryClick(
                                              component,
                                              index
                                            )
                                          }
                                          size="small"
                                        >
                                          <EditIcon
                                            fontSize="large"
                                            style={{ color: "#ec6535" }}
                                          />
                                        </IconButton>
                                      )}
                                  </>
                                )}
                              </TableCell>
                            )}
                          </TableRow>
                        ))
                      ) : (
                        // Case 3: Fallback - Display component data with "NA" values when no lot or inventory data available
                        <TableRow style={{ width: "100%" }}>
                          <TableCell style={{ width: "23%" }} align="left">
                            <div>
                              {presentFormatedData(
                                component?.componentAllocationDetails
                                  ?.componentCode,
                                "NA"
                              )}
                              {"/"}
                            </div>
                            <div>
                              {presentFormatedData(
                                component?.componentAllocationDetails
                                  ?.componentName,
                                "NA"
                              )}
                            </div>
                          </TableCell>

                          <TableCell style={{ width: "11%" }} align="right">
                            {component?.componentAllocationDetails
                              ?.componentQuantity !== undefined &&
                            component?.componentAllocationDetails
                              ?.componentQuantity !== null
                              ? Number(
                                  component?.componentAllocationDetails
                                    ?.componentQuantity
                                ).toFixed(3)
                              : "NA"}
                          </TableCell>
                          <TableCell
                            style={{ width: "11%", paddingLeft: "3%" }}
                            align="left"
                          >
                            {presentFormatedData(
                              component?.componentAllocationDetails?.uom,
                              "NA"
                            )}
                          </TableCell>
                          <TableCell
                            style={{ width: "11%", whiteSpace: "nowrap" }}
                            align="left"
                          >
                            NA
                          </TableCell>
                          <TableCell style={{ width: "11%" }} align="right">
                            NA
                          </TableCell>
                          <TableCell
                            style={{ width: "16%", paddingLeft: "3%" }}
                            align="left"
                          >
                            NA
                          </TableCell>

                          <TableCell
                            style={{ width: "16%", whiteSpace: "nowrap" }}
                            align="right"
                          >
                            NA
                            {/* {showPencilButton &&
                              localStorage.collabType !== "CMO" &&
                              featuresAccess?.editPlannedAllocatedQty && 
                              // (
                                //&& data?.scheduleLineDetails?.plannerEmailID ===decoded.email_address
                                (<IconButton
                                  onClick={() =>
                                    handleOpenDialog(
                                      component,
                                      component?.componentAllocationDetails
                                        ?.componentCode
                                    )
                                  }
                                >
                                  <EditIcon
                                    fontSize="large"
                                    style={{
                                      cursor: "pointer",
                                      color: "#EC6535",
                                      //fontSize: "large",
                                      // color:

                                      //   component.lotNumberAllocationDetails
                                      //     .length > 0
                                      //     ? "#EC6535"
                                      //     : "red",
                                    }}
                                  />
                                </IconButton>
                              )} */}
                            {
                              <IconButton
                                onClick={() =>
                                  handleOpenPlannedQtyDialog(component)
                                }
                                disabled={!canEditFields}
                                className={classes.editIconButton}
                              >
                                <EditIcon
                                  fontSize="large"
                                  style={{
                                    color: "#ec6535",
                                  }}
                                />
                              </IconButton>
                              // </>
                            }
                            {/* </div>
                            </div> */}
                          </TableCell>
                          <TableCell style={{ width: "11%" }} align="left">
                            {editingBatchRow ===
                            `${component?.componentAllocationDetails?.componentCode}-${index}` ? (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "flex-start",
                                  gap: "4px",
                                }}
                              >
                                <TextField
                                  placeholder="164859141N, 164859142N"
                                  value={plannedBatchNumber}
                                  onChange={handlePlannedBatchNumberChange}
                                  onBlur={handlePlannedBatchNumberBlur}
                                  variant="outlined"
                                  size="small"
                                  fullWidth
                                  multiline
                                  minRows={1}
                                  InputProps={{
                                    style: {
                                      fontSize: "14px",
                                      lineHeight: "1.4",
                                      padding: "8px 12px",
                                    },
                                  }}
                                  style={{ backgroundColor: "#fff" }}
                                />
                                <Box
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "3px",
                                  }}
                                >
                                  <span title="save">
                                    <SaveIcon
                                      onClick={
                                        plannedBatchNumber.trim() ||
                                        component?.componentAllocationDetails
                                          ?.plannedLotNumbers
                                          ? handleSavePlannedBatch
                                          : undefined
                                      }
                                      style={{
                                        cursor: "pointer",
                                        fontSize: "small",
                                      }}
                                    />
                                  </span>
                                  <span title="clear">
                                    <ClearIcon
                                      onClick={handleCancelEdit}
                                      style={{
                                        cursor: "pointer",
                                        fontSize: "small",
                                      }}
                                    />
                                  </span>
                                </Box>
                              </div>
                            ) : (
                              <>
                                {presentFormatedData(
                                  component?.componentAllocationDetails
                                    ?.plannedLotNumbers,
                                  "NA"
                                )}
                                {canEditFields &&
                                  localStorage.getItem("collabType") !==
                                    "CMO" && (
                                    <IconButton
                                      onClick={() =>
                                        handleOpenPlannedBatchDialog(
                                          null,
                                          component,
                                          index
                                        )
                                      }
                                      size="small"
                                    >
                                      <EditIcon
                                        fontSize="large"
                                        style={{ color: "#ec6535" }}
                                      />
                                    </IconButton>
                                  )}
                              </>
                            )}
                          </TableCell>
                          <TableCell
                            style={{ width: "11%", minWidth: "100px" }}
                            align="left"
                          >
                            {editingCountryRow ===
                            `${component?.componentAllocationDetails?.componentCode}-${index}` ? (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "flex-start",
                                  gap: "4px",
                                }}
                              >
                                <TextField
                                  placeholder="Enter Country"
                                  value={countryOfOrigin}
                                  onChange={handleCountryOfOriginChange}
                                  onBlur={handleCountryOfOriginBlur}
                                  variant="outlined"
                                  size="small"
                                  fullWidth
                                  multiline
                                  minRows={1}
                                  InputProps={{
                                    style: {
                                      fontSize: "14px",
                                      lineHeight: "1.4",
                                      // padding: '8px 12px'
                                    },
                                  }}
                                  style={{ backgroundColor: "#fff" }}
                                />
                                <Box
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "3px",
                                  }}
                                >
                                  <span title="save">
                                    <SaveIcon
                                      onClick={
                                        countryOfOrigin.trim() ||
                                        component?.componentAllocationDetails
                                          ?.countryOfOrigin
                                          ? () => handleSaveCountry(component)
                                          : undefined
                                      }
                                      style={{
                                        cursor: "pointer",
                                        fontSize: "small",
                                      }}
                                    />
                                  </span>
                                  <span title="clear">
                                    <ClearIcon
                                      onClick={handleCancelCountryEdit}
                                      style={{
                                        cursor: "pointer",
                                        fontSize: "small",
                                      }}
                                    />
                                  </span>
                                </Box>
                              </div>
                            ) : (
                              <>
                                {presentFormatedData(
                                  component?.componentAllocationDetails
                                    ?.countryOfOrigin,
                                  "NA"
                                )}
                                {canEditFields &&
                                  localStorage.getItem("collabType") !==
                                    "CMO" && (
                                    <IconButton
                                      onClick={() =>
                                        handleEditCountryClick(component, index)
                                      }
                                      size="small"
                                    >
                                      <EditIcon
                                        fontSize="large"
                                        style={{ color: "#ec6535" }}
                                      />
                                    </IconButton>
                                  )}
                              </>
                            )}
                          </TableCell>
                        </TableRow>
                      )}
                    </React.Fragment>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={9} align="center">
                      No data available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            )}
          </Table>
        </TableContainer>

        </>
      )}

      <div style={{display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
        {/* Approve/Reject Allocation Buttons - Hidden while data is being fetched */}
        {canUserApprove() && !tableLoading && (
          <Box
            style={{
              marginTop: "1rem",
              marginBottom: "1rem",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item>
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: "#ec6535",
                    color: "#fff",
                    textTransform: "none",
                    borderRadius: "20px",
                    padding: "8px 24px",
                    fontSize: "0.95rem",
                  }}
                  disableElevation
                  onClick={() => handleApproveRejectAllocation("Approve")}
                >
                  Approve allocation
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="outlined"
                  style={{
                    backgroundColor: "#fff",
                    color: "#000",
                    textTransform: "none",
                    borderRadius: "20px",
                    padding: "8px 24px",
                    fontSize: "0.95rem",
                    border: "1px solid #ccc",
                  }}
                  disableElevation
                  onClick={() => handleApproveRejectAllocation("Reject")}
                >
                  Reject allocation
                </Button>
              </Grid>
            </Grid>
            
          </Box>
        )}

        {/* Generate PDF for Existing Allocation Button */}
        {batchAllocationPDFNotificationReqd && !tableLoading && !error && lotAllocationData?.length > 0 && !hasApprovalRejection() && !areAllPlannedAllocatedQuantitiesNA() && !lotAllocationRes?.generateAllocationPDF && (
          <div style={{ marginTop: "1rem", marginBottom: "1rem", marginLeft: "1rem", display: "flex", justifyContent: "flex-end" }}>
            <Button
              variant="outlined"
              onClick={handleContinueToGeneratePdf}
              style={{
                textTransform: "none",
                borderRadius: "25px",
                padding: "6px 16px",
                fontSize: "0.875rem",
                borderColor: "#666",
                color: "#333",
              }}
            >
              Generate PDF for Existing Allocation
            </Button>
          </div>
        )}

        {/* Download PDF Button - Show when workflow exists (unless rejected), disabled until all approvals complete */}
        {batchAllocationPDFNotificationReqd && !tableLoading && !error && lotAllocationData?.length > 0 && !hasApprovalRejection() && !areAllPlannedAllocatedQuantitiesNA() && lotAllocationRes?.generateAllocationPDF && (
          <div style={{ marginTop: "1rem", marginBottom: "1rem", marginLeft: "1rem", display: "flex", justifyContent: "flex-end" }}>
            <Box style={{ display: "flex", alignItems: "center" }}>
              <GetAppIcon style={{ 
                fontSize: "20px", 
                color: areAllApprovalsComplete() ? "#1976d2" : "#64bdfe", 
                marginRight: "4px" 
              }} />
              <Typography
                variant="body2"
                style={{
                  color: areAllApprovalsComplete() ? "#1976d2" : "#64bdfe",
                  cursor: areAllApprovalsComplete() ? "pointer" : "not-allowed",
                  textDecoration: areAllApprovalsComplete() ? "underline" : "none",
                  fontSize: "0.95rem",
                  opacity: areAllApprovalsComplete() ? 1 : 1,
                }}
                onClick={areAllApprovalsComplete() ? handleDownloadPdfFromBase64 : undefined}
              >
                {(() => {
                  const allDates = [];
                  
                  // Extract all lastUpdatedDate from lotNumberAllocationDetails
                  lotAllocationData?.forEach(component => {
                    if (component?.lotNumberAllocationDetails && component.lotNumberAllocationDetails.length > 0) {
                      component.lotNumberAllocationDetails.forEach(lot => {
                        if (lot?.lastUpdatedDate) {
                          allDates.push(lot.lastUpdatedDate);
                        }
                      });
                    }
                  });
                  
                  // Get the latest date
                  const latestDate = allDates.length > 0 
                    ? new Date(allDates.sort().reverse()[0]).toLocaleString('en-GB', { 
                        day: '2-digit', 
                        month: 'short', 
                        year: 'numeric', 
                        hour: '2-digit', 
                        minute: '2-digit', 
                        second: '2-digit', 
                        hour12: false 
                      }).replace(/,/g, '').replace(/ /g, ' ').toUpperCase()
                    : new Date().toLocaleString('en-GB', { 
                        day: '2-digit', 
                        month: 'short', 
                        year: 'numeric', 
                        hour: '2-digit', 
                        minute: '2-digit', 
                        second: '2-digit', 
                        hour12: false 
                      }).replace(/,/g, '').replace(/ /g, ' ').toUpperCase();
                  
                  return `PO_${data?.scheduleLineDetails?.scheduleAgreementNumber || ''}_Batch Allocation_${latestDate}`;
                })()}
              </Typography>
            </Box>
          </div>
        )}
      </div>

      {/* Approval Workflow Note */}
          {batchAllocationPDFNotificationReqd && approvalNote && localStorage.getItem("collabType") === "Pharma Co" && !hasApprovalRejection() && !areAllPlannedAllocatedQuantitiesNA() && (
            <Box
              style={{
                marginTop: "1rem",
                padding: "12px 16px",
                // backgroundColor: "#fff3cd",
                border: "1px solid #000",
                borderRadius: "4px",
                display: "flex",
                alignItems: "flex-start",
                fontSize: "0.875rem",
              }}
            >
              <Typography
                variant="body2"
                style={{
                  // color: "#856404",
                  fontSize: "0.875rem",
                  lineHeight: "1.5",
                  fontWeight: 500,
                }}
              >
                <span style={{fontWeight: 500}}>Note - </span>{approvalNote}
              </Typography>
            </Box>
          )}

      {lotAllocationRes?.consumptionDataReqdForIBDGRN &&
        typeof lotAllocationRes?.allocationOwnedBySponsor === "boolean" && (
          <div
            style={{
              marginTop: "1rem",
              padding: "0.75rem 1rem",
              backgroundColor: "#fff",
              border: "1px solid #0b0b0bff",
              borderRadius: "4px",
              fontSize: "0.875rem",
            }}
          >
            <Typography variant="body2">
              {lotAllocationRes?.allocationOwnedBySponsor
                ? `Note - Allocation is owned by ${
                    data?.scheduleLineDetails?.sponsorName
                      ? data.scheduleLineDetails.sponsorName
                      : "BMS"
                  }`
                : `Note - Allocation is not owned by ${
                    data?.scheduleLineDetails?.sponsorName
                      ? data.scheduleLineDetails.sponsorName
                      : "BMS"
                  }`}
            </Typography>
          </div>
        )}

      {typeof lotAllocationRes?.consumptionDataReqdForIBDGRN === "boolean" &&
        lotAllocationRes?.consumptionDataReqdForIBDGRN === false && (
          <div
            style={{
              marginTop: "1rem",
              padding: "0.75rem 1rem",
              backgroundColor: "#fff",
              border: "1px solid #0b0b0bff",
              borderRadius: "4px",
              fontSize: "0.875rem",
            }}
          >
            <Typography variant="body2">
              {!lotAllocationRes?.consumptionDataReqdForIBDGRN &&
                `Note - Consumption Information is not required for IBD/GRN`}
            </Typography>
          </div>
        )}
      {/* BOM Change Warning Message */}
      {data?.scheduleLineDetails?.editPlannedAllocation === false && 
       data?.scheduleLineDetails?.changeInBOM === true && data?.batchDetails?.bomConsumptionAddedIndicator === false && (
        <div style={{
          marginTop: "1rem",
          padding: "0.75rem 1rem",
          backgroundColor: "#FFF0F0",
          border: "1px solid #FF0000",
          borderRadius: "4px",
          fontSize: "0.875rem",
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
          maxWidth: '592px',
          marginLeft: 'auto',
        }}>
          <WarningIcon style={{ color: "#FF0000", fontSize: "1.25rem" }} />
          <Typography variant="body2" style={{ color: "#f00", lineHeight: "1.5" }}>
            Material Code / Description was changed in BMS SAP. PO is not in the limit of allowing<br/> batch allocation change. Please change the PO delivery date to enable batch allocation.
          </Typography>
        </div>
      )}

      {/* Over-allocation Note - Only for CMO */}
      {/* {localStorage.collabType === "CMO" &&
        overAllocatedComponents.length > 0 && (
          <div
            style={{
              marginTop: "1rem",
              padding: "0.75rem 1rem",
              backgroundColor: "#FFF4E5",
              border: "1px solid #FFB74D",
              borderRadius: "4px",
              fontSize: "0.875rem",
            }}
          >
            <Typography variant="body2">
              Instruction - Deplete allocated batch(es) for BMS Material{" "}
              {overAllocatedComponents.map((component, index) => (
                <span key={index}>
                  {component?.componentAllocationDetails?.componentCode} /{" "}
                  {component?.componentAllocationDetails?.componentName}
                  {index < overAllocatedComponents.length - 1 ? ", " : ""}
                </span> 
              ))}
            </Typography>
          </div>
        )}

     
      {localStorage.collabType === "CMO" &&
        underAllocatedComponents.length > 0 && (
          <div
            style={{
              marginTop: "1rem",
              padding: "0.75rem 1rem",
              backgroundColor: "#FFF4E5",
              border: "1px solid #FFB74D",
              borderRadius: "4px",
              fontSize: "0.875rem",
            }}
          >
            <Typography variant="body2">
              Instruction - Deplete allocated batch(es) for BMS Material{" "}
              {underAllocatedComponents.map((component, index) => (
                <span key={index}>
                  {component?.componentAllocationDetails?.componentCode} /{" "}
                  {component?.componentAllocationDetails?.componentName}
                  {index < underAllocatedComponents.length - 1 ? ", " : ""}
                </span>
              ))}
            </Typography>
          </div>
        )} */}

      {/* Deplete Instruction Note - For multiple batches */}
      {depleteInstructionComponents.length > 0 && (
        <div
          style={{
            marginTop: "1rem",
            padding: "0.75rem 1rem",
            //backgroundColor: "#FFF4E5",
            border: "1px solid black",
            borderRadius: "4px",
            fontSize: "0.875rem",
          }}
        >
          <Typography variant="body2">
            Instruction - Deplete allocated batch(es) for BMS Material{" "} Code(s){" "}
            {depleteInstructionComponents.map((component, compIndex) => (
              <span key={compIndex}>
                {component.componentCode}
                {component.batches.length > 0 && (
                  <span>
                    {" "}
                    ({component.batches.map((batch, batchIndex) => (
                      <span key={batchIndex}>
                        Batch {batch}
                        {batchIndex < component.batches.length - 1 ? ", " : ""}
                      </span>
                    ))})
                  </span>
                )}
                {compIndex < depleteInstructionComponents.length - 1 ? ", " : ""}
              </span>
            ))}
          </Typography>
        </div>
      )}

      

      {/* Inventory Dialog */}
      <Dialog
        open={openDialog}
        // onClose={handleCloseDialog}
        maxWidth="md"
        fullWidth
      >
        <EditPlannedAllocatedQuantityDialog
          lotData={selectedLotData}
          lotAllocationRes={lotAllocationRes}
          lotAllocationData={lotAllocationData}
          rmPmCode={rmPmCode}
          onClose={handleCloseDialog}
          poData={data}
          schrockenSLID={data?.scheduleLineDetails?.schrockenSLID}
          vendorMosymphonyID={data?.scheduleLineDetails?.vendorMosymphonyID}
          handleClose={handleLotAllocationStatus}
        />
      </Dialog>

      {/* Delete Dialog */}
      <Dialog open={openDeleteDialog} maxWidth="md" fullWidth>
        <DeleteLotAllocationDialog
          open={openDeleteDialog}
          onClose={handleCloseDeleteDialog}
          lotData={selectedLotForDelete}
          componentData={selectedComponentForDelete}
          poData={data}
          schrockenSLID={data?.scheduleLineDetails?.schrockenSLID}
          vendorMosymphonyID={data?.scheduleLineDetails?.vendorMosymphonyID}
          lotAllocationRes={lotAllocationRes}
          onSuccess={handleDeleteStatus}
          shouldTrackDeletion={hasEnabledApprovalFlag()}
          poNumber={data?.scheduleLineDetails?.scheduleAgreementNumber}
        />
      </Dialog>

      {/* <Dialog
        open={successDialogBox.openDialogBox}
        disableBackdropClick // Disable closing on outside click
        disableEscapeKeyDown // Disable closing on escape key
        maxWidth='sm'
        fullWidth
        classes={{ paper: classes.dialogPaper }}
      >
        <DialogContent className={classes.dialogContent}>
          <CheckCircleIcon className={classes.avatar} />
          <Typography
            style={{
              marginTop: "10px",
              fontWeight: "600",
              color: "black",
              fontSize: "1.4rem",
            }}
          >
            Component Allocation updated successfully
          </Typography>
          <DialogActions className={classes.dialogActions}>
            <Button
              variant='contained'
              color='primary'
              endIcon={<ChevronRight />}
              style={{
                borderRadius: "20px",
                textTransform: "none",
              }}
              onClick={() => {
                handleRefresh();
                setSuccessDialogBox({
                  openDialogBox: false,
                  // dialogBoxType: "",
                });
              }}
            >
              Ok
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog> */}

      {/* Edit Success Dialog - Show PDF flow only when both conditions are met */}
      <Dialog open={editSuccessDialogOpen && showPdfGenerationFlow && batchAllocationPDFNotificationReqd} fullWidth maxWidth="lg" PaperProps={{ style: { maxWidth: lotAllocationData?.length > 1 ? "840px" : "580px" } }}>
        <DialogContent style={{ padding: "3rem 2rem", textAlign: "center" }}>
          <Grid container direction="column" alignItems="center" spacing={3}>
            {/* Success Icon */}
            <Grid item style={{paddingBottom: 0}}>
              <CheckCircleIcon style={{ fontSize: "4rem", color: "#28a745" }} />
            </Grid>
            
            {/* Success Message */}
            <Grid item>
              <Typography variant="h6" style={{ fontWeight: 600, fontSize: "1.5rem" }}>
                Batch Allocation updated successfully
              </Typography>
            </Grid>

            {/* Instruction Text - Only show for multiple materials/components */}
            {lotAllocationData?.length > 1 && (
              <Grid item style={{ width: "100%"}}>
                <Typography variant="body1" style={{ textAlign: "center", fontSize: "18px", color: "#333" }}>
                  There are multiple materials/components in this PO. Please<br/> confirm if you want to complete/change allocation for the other<br/> materials/components and then generate PDF notification.
                </Typography>
              </Grid>
            )}

            {/* Action Buttons */}
            <Grid item container spacing={4} justifyContent="center" style={{ marginTop: lotAllocationData?.length > 1 ? "0.2rem" : null }}>
              {lotAllocationData?.length > 1 ? (
                <>
                  <Grid item>
                    <Button
                      variant="outlined"
                      onClick={handleContinueToGeneratePdf}
                      style={{
                        borderRadius: "25px",
                        textTransform: "none",
                        padding: "8px 15px",
                        fontSize: "14px",
                        borderColor: "#666",
                        fontWeight: 600,
                      }}
                    >
                      Continue without further allocations
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      onClick={handleAllocateRemainingMaterials}
                      style={{
                        borderRadius: "25px",
                        textTransform: "none",
                        padding: "8px 15px",
                        fontSize: "14px",
                        backgroundColor: "#ec6535",
                        color: "#fff"
                      }}
                    >
                      Allocate batch for remaining materials/components
                    </Button>
                  </Grid>
                </>
              ) : (
                <Grid item>
                  <Button
                    variant="contained"
                    onClick={handleContinueToGeneratePdf}
                    style={{
                      borderRadius: "25px",
                      textTransform: "none",
                      padding: "8px 15px",
                      fontSize: "14px",
                      backgroundColor: "#ec6535",
                      color: "#fff"
                    }}
                  >
                    Continue to generate PDF
                  </Button>
                </Grid>
              )}
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
      
      {/* Simple Success Dialog - for non-PDF updates or when PDF flow is disabled */}
      <Dialog open={editSuccessDialogOpen && (!showPdfGenerationFlow || !batchAllocationPDFNotificationReqd)} fullWidth>
        <StyledDialog
          icons={true}
          handleClose={() => {
            setEditSuccessDialogOpen(false);
            setEditSuccessMessage("");
            setShowPdfGenerationFlow(true); // Reset to default
            handleRefreshLotAllocation();
          }}
          title={editSuccessMessage || "Component Allocation updated successfully"}
        />
      </Dialog>

      {/* PDF Generation Dialog */}
      <Dialog open={pdfGenerationDialogOpen} fullWidth maxWidth="sm">
        <DialogContent style={{ padding: "3rem 2rem", textAlign: "center" }}>
          <Grid container direction="column" alignItems="center" spacing={3}>
            {/* Close Button */}
            <Grid item style={{ width: "100%", display: "flex", justifyContent: "flex-end", padding: 0 }}>
              <Box style={{ display: "flex", alignItems: "center", cursor: "pointer" }} onClick={() => setPdfGenerationDialogOpen(false)}>
                <Typography variant="body2" style={{ marginRight: "8px", fontWeight: 500 }}>Cancel</Typography>
                <CloseIcon style={{ color: "#FF0000" }} />
              </Box>
            </Grid>
            {/* Title */}
            <Grid item>
              <Typography variant="h6" style={{ fontWeight: 600, fontSize: "1.5rem" }}>
                Generating PDF notification for Allocation
              </Typography>
            </Grid>

            {/* Checkboxes Section */}
            <Grid item style={{ width: "100%", marginTop: "1rem" }}>
              <Typography variant="body2" style={{ textAlign: "left", marginBottom: "12px", fontWeight: 600 }}>
                Select Information Required in Batch Allocation PDF
              </Typography>
              
              {/* Validation Error Message */}
              {pdfFieldValidationError && (
                <div
                  style={{
                    padding: "12px 16px",
                    backgroundColor: "#FFF0F0",
                    border: "1px solid #FF0000",
                    borderRadius: "4px",
                    fontSize: "0.875rem",
                    marginBottom: "1rem",
                  }}
                >
                  <Typography
                    variant="body2"
                    style={{
                      color: "#FF0000",
                      fontSize: "0.875rem",
                      lineHeight: "1.5",
                      fontWeight: 500,
                    }}
                  >
                    {pdfFieldValidationError}
                  </Typography>
                </div>
              )}
              
              <Box style={{ display: "flex", gap: "24px", marginBottom: "1.5rem" }}>
                <Box style={{ display: "flex", alignItems: "center" }}>
                  <input
                    type="checkbox"
                    checked={includeDocumentId}
                    onChange={(e) => {
                      setIncludeDocumentId(e.target.checked);
                      if (!e.target.checked) {
                        setDocumentId("");
                        setPdfFieldValidationError("");
                      }
                    }}
                    style={{
                      width: "18px",
                      height: "18px",
                      cursor: "pointer",
                      accentColor: "#ec6535"
                    }}
                  />
                  <Typography variant="body2" style={{ marginLeft: "8px", fontSize: "1rem" }}>
                    Document ID
                  </Typography>
                </Box>
                <Box style={{ display: "flex", alignItems: "center" }}>
                  <input
                    type="checkbox"
                    checked={includeBomCode}
                    onChange={(e) => {
                      setIncludeBomCode(e.target.checked);
                      if (!e.target.checked) {
                        setBomCode("");
                        setPdfFieldValidationError("");
                      }
                    }}
                    style={{
                      width: "18px",
                      height: "18px",
                      cursor: "pointer",
                      accentColor: "#ec6535"
                    }}
                  />
                  <Typography variant="body2" style={{ marginLeft: "8px", fontSize: "1rem" }}>
                    BoM Code
                  </Typography>
                </Box>
                <Box style={{ display: "flex", alignItems: "center" }}>
                  <input
                    type="checkbox"
                    checked={includeArtworkCode}
                    onChange={(e) => {
                      setIncludeArtworkCode(e.target.checked);
                      if (!e.target.checked) {
                        setArtworkCode("");
                        setPdfFieldValidationError("");
                      }
                    }}
                    style={{
                      width: "18px",
                      height: "18px",
                      cursor: "pointer",
                      accentColor: "#ec6535"
                    }}
                  />
                  <Typography variant="body2" style={{ marginLeft: "8px", fontSize: "1rem" }}>
                    Artwork Code
                  </Typography>
                </Box>
              </Box>
            </Grid>

            {/* Document ID Input */}
            <Grid item style={{ width: "100%" }}>
              <Typography variant="body2" style={{ textAlign: "left", marginBottom: "8px", fontWeight: 600, color: includeDocumentId ? "inherit" : "#9e9e9e" }}>
                Document ID {includeDocumentId && <span style={{ color: "#FF0000" }}>*</span>}
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Enter value here"
                value={documentId}
                onChange={(e) => {
                  setDocumentId(e.target.value);
                  if (pdfFieldValidationError) setPdfFieldValidationError("");
                }}
                onBlur={(e) => {
                  setDocumentId(e.target.value.trim());
                }}
                size="small"
                disabled={!includeDocumentId}
              />
            </Grid>

            {/* BoM Code Input */}
            <Grid item style={{ width: "100%" }}>
              <Typography variant="body2" style={{ textAlign: "left", marginBottom: "8px", fontWeight: 600, color: includeBomCode ? "inherit" : "#9e9e9e" }}>
                BoM Code {includeBomCode && <span style={{ color: "#FF0000" }}>*</span>}
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Enter value here"
                value={bomCode}
                onChange={(e) => {
                  setBomCode(e.target.value);
                  if (pdfFieldValidationError) setPdfFieldValidationError("");
                }}
                onBlur={(e) => {
                  setBomCode(e.target.value.trim());
                }}
                size="small"
                disabled={!includeBomCode}
              />
            </Grid>

            {/* Artwork Code Input */}
            <Grid item style={{ width: "100%" }}>
              <Typography variant="body2" style={{ textAlign: "left", marginBottom: "8px", fontWeight: 600, color: includeArtworkCode ? "inherit" : "#9e9e9e" }}>
                Artwork Code {includeArtworkCode && <span style={{ color: "#FF0000" }}>*</span>}
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Enter value here"
                value={artworkCode}
                onChange={(e) => {
                  setArtworkCode(e.target.value);
                  if (pdfFieldValidationError) setPdfFieldValidationError("");
                }}
                onBlur={(e) => {
                  setArtworkCode(e.target.value.trim());
                }}
                size="small"
                multiline
                minRows={2}
                disabled={!includeArtworkCode}
              />
            </Grid>

            {/* Instructions Text */}
            <Grid item style={{ width: "100%", marginTop: "0.5rem" }}>
              <Typography variant="body2" style={{ textAlign: "center", fontSize: "0.95rem", lineHeight: "1.6"}}>
                Select if you need approvals or not before sharing the PDF with CMO
              </Typography>
            </Grid>

            {/* Action Buttons */}
            <Grid item container spacing={2} justifyContent="center" style={{ marginTop: "0.5rem" }}>
              <Grid item>
                <Button
                  variant="outlined"
                  onClick={handleShareWithoutApprovals}
                  disabled={sharingWithoutApproval}
                  style={{
                    borderRadius: "25px",
                    textTransform: "none",
                    padding: "8px 20px",
                    fontSize: "14px",
                    borderColor: "#666",
                    color: "#666"
                  }}
                >
                  {sharingWithoutApproval ? (
                    <>
                      <CircularProgress size={20} style={{ marginRight: "8px" }} />
                      Sharing...
                    </>
                  ) : (
                    "Share without approvals"
                  )}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  onClick={handleShareAfterApprovals}
                  disabled={sharingWithoutApproval}
                  style={{
                    borderRadius: "25px",
                    textTransform: "none",
                    padding: "8px 20px",
                    fontSize: "14px",
                    backgroundColor: "#ec6535",
                    color: "#fff"
                  }}
                >
                  Share after approvals
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      {/* Delete Success Dialog */}
      <Dialog open={deleteSuccessDialogOpen} fullWidth>
        <StyledDialog
          icons={true}
          handleClose={() => {
            setDeleteSuccessDialogOpen(false);
            handleRefreshLotAllocation();
          }}
          title="Batch Allocation updated Successfully"
        />
      </Dialog>

      {/* Share Success Dialog */}
      <Dialog open={shareSuccessDialogOpen} fullWidth maxWidth="sm">
        <DialogContent style={{ padding: "3rem 2rem", textAlign: "center" }}>
          <Grid container direction="column" alignItems="center" spacing={3}>
            {/* Success Icon */}
            <Grid item>
              <CheckCircleIcon style={{ fontSize: "4rem", color: "#28a745" }} />
            </Grid>
            
            {/* Success Message */}
            <Grid item>
              <Typography variant="h6" style={{ fontWeight: 600, fontSize: "1.25rem" }}>
                Allocation change PDF shared successfully
              </Typography>
            </Grid>

            {/* OK Button */}
            <Grid item style={{ marginTop: "1rem" }}>
              <Button
                variant="contained"
                onClick={() => {
                  setShareSuccessDialogOpen(false);
                  handleRefreshLotAllocation();
                }}
                style={{
                  borderRadius: "25px",
                        textTransform: "none",
                        padding: "8px 15px",
                        fontSize: "14px",
                  backgroundColor: "#ec6535",
                  color: "#fff"
                }}
              >
                Ok
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      {/* Workflow Dialog workflowDialogOpen */}
      <Dialog open={workflowDialogOpen} fullWidth maxWidth="lg">
        <DialogContent style={{ padding: "2rem" }}>
          <Grid container>
            {/* Header */}
            <Grid item xs={12} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.5rem" }}>
              <Typography variant="h6" style={{ fontWeight: 600, fontSize: "1.25rem" }}>
                Define review/approval workflow
              </Typography>
              <Box style={{ display: "flex", alignItems: "center", cursor: "pointer" }} onClick={() => setWorkflowDialogOpen(false)}>
                <Typography variant="body2" style={{ marginRight: "8px", fontWeight: 500 }}>Close</Typography>
                <CloseIcon style={{ color: "#FF0000" }} />
              </Box>
            </Grid>

            {/* Workflow details label */}
            <Grid item xs={12} style={{ marginBottom: "1rem" }}>
              <Typography variant="body1" style={{ fontWeight: 600 }}>
                Workflow details <span style={{ color: "#FF0000" }}>*</span>
              </Typography>
            </Grid>

            {/* Validation Error Message */}
            {workflowValidationError && (
              <Grid item xs={12} style={{ marginBottom: "1rem" }}>
                <div
                  style={{
                    padding: "12px 16px",
                    backgroundColor: "#FFF0F0",
                    border: "1px solid #FF0000",
                    borderRadius: "4px",
                    fontSize: "0.875rem",
                  }}
                >
                  <Typography
                    variant="body2"
                    style={{
                      color: "#FF0000",
                      fontSize: "0.875rem",
                      lineHeight: "1.5",
                      fontWeight: 500,
                    }}
                  >
                    {workflowValidationError}
                  </Typography>
                </div>
              </Grid>
            )}

            {/* Table */}
            <Grid item xs={12} style={{ marginBottom: "1.5rem" }}>
              <TableContainer component={Paper} style={{ border: "1px solid #e0e0e0" }}>
                <Table>
                  <TableHead style={{ backgroundColor: "#f5f5f5" }}>
                    <TableRow>
                      <TableCell style={{ fontWeight: 600, color: "#00000061" }}>Requirement</TableCell>
                      <TableCell style={{ fontWeight: 600 }}>Approver Org</TableCell>
                      <TableCell style={{ fontWeight: 600 }}>Assigned team member</TableCell>
                      <TableCell style={{ fontWeight: 600, color: "#00000061" }}>Signature</TableCell>
                      <TableCell style={{ fontWeight: 600 }}>Change order</TableCell>
                      <TableCell style={{ fontWeight: 600 }}>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {approvers.map((approver, index) => (
                      <TableRow 
                        key={approver.id}
                        draggable
                        onDragStart={(e) => handleDragStart(e, index)}
                        onDragOver={(e) => handleDragOver(e, index)}
                        onDragEnd={handleDragEnd}
                        style={{
                          cursor: "move",
                          backgroundColor: draggedItem === index ? "#f0f0f0" : "transparent"
                        }}
                      >
                        <TableCell>
                          <TextField
                            select
                            value={approver.requirement}
                            size="small"
                            fullWidth
                            variant="outlined"
                            disabled
                            SelectProps={{
                              native: true,
                            }}
                          >
                            <option value="Approval">Approval</option>
                          </TextField>
                        </TableCell>
                        <TableCell>{approver.approverOrg}</TableCell>
                        <TableCell>
                          <Autocomplete
                            value={teamMembers.find(member => member.email === approver.assignedMember) || null}
                            onChange={(event, newValue) => {
                              handleUpdateAssignedMember(approver.id, newValue?.email || "");
                            }}
                            options={teamMembers.filter(member => 
                              member.email !== tokenData.email_address &&
                              !approvers.some(app => app.id !== approver.id && app.assignedMember === member.email)
                            )}
                            getOptionLabel={(option) => option.label || ""}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                size="small"
                                variant="outlined"
                                placeholder="Select from this list"
                                className={classes.blackBorderFieldset}
                              />
                            )}
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            select
                            value={approver.signature}
                            size="small"
                            fullWidth
                            variant="outlined"
                            disabled
                            SelectProps={{
                              native: true,
                            }}
                          >
                            <option value="Electronic">Electronic</option>
                          </TextField>
                        </TableCell>
                        <TableCell>
                          {/* <DragIndicatorIcon style={{ fontSize: "24px", color: "#999", cursor: "move" }} /> */}
                          <i className="fa fa-arrows-alt" style={{color: "#00000061"}} />
                        </TableCell>
                        <TableCell>
                          {index === 0 ? null : (
                            <IconButton size="small" onClick={() => handleRemoveApprover(approver.id)}>
                              <DeleteIcon style={{ fontSize: "20px", color: "#FF0000" }} />
                            </IconButton>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>

            {/* Add approver button */}
            <Grid item xs={12} style={{ marginBottom: "2rem" }}>
              <Button
                variant="outlined"
                onClick={handleAddApprover}
                style={{
                  borderRadius: "40px",
                  textTransform: "none",
                  padding: "8px 20px",
                  fontSize: "0.95rem",
                  borderColor: "#000",
                  color: "#000"
                }}
              >
                <Box style={{ 
                  border: "2px solid #000", 
                  borderRadius: "50%", 
                  width: "20px", 
                  height: "20px", 
                  display: "flex", 
                  alignItems: "center", 
                  justifyContent: "center",
                  fontSize: "16px",
                  marginRight: "8px"
                }}>+</Box>
                Add approver
              </Button>
            </Grid>

            {/* Save button */}
            <Grid item xs={12} style={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                onClick={handleSaveWorkflow}
                disabled={savingWorkflow}
                endIcon={savingWorkflow ? <CircularProgress size={20} style={{ color: "white" }} /> : <span style={{ fontSize: "18px" }}>›</span>}
                style={{
                  borderRadius: "25px",
                        textTransform: "none",
                        padding: "8px 15px",
                        fontSize: "14px",
                  backgroundColor: "#ec6535",
                  color: "#fff",
                  opacity: savingWorkflow ? 0.8 : 1
                }}
              >
                {savingWorkflow ? "Saving..." : "Save and send for review/approval"}
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      <Dialog
        open={saveFailed}
        onClose={() => {
          setSaveFailed(false);
        }}
        fullWidth
      >
        <DialogContent style={{ padding: "2rem" }}>
          <Grid container justifyContent="flex-end">
            <Typography
              variant="body2"
              style={{
                fontSize: "1rem",
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                setSaveFailed(false);
              }}
            >
              Close <CloseIcon fontSize="large" />
            </Typography>
            <Grid
              item
              xs={12}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <WarningIcon
                style={{
                  fontSize: "5rem",
                  color: "#F00",
                }}
              />
            </Grid>
          </Grid>
          <div
            style={{
              display: "flex",
              justifyContent: "center", // Horizontally center the CircularProgress
              alignItems: "center", // Vertically center the CircularProgress
              height: "80px", // Optional: Set a height to vertically center the loader
              border: "2px solid #FF0000",
              backgroundColor: "#FFF0F0",
              // width: "100%",
            }}
          >
            <Typography style={{ textAlign: "center" }}>
              Something went wrong. Please try again.
            </Typography>
          </div>

          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              padding: "0.5rem",
            }}
          >
            <StyledButton
              style={{ borderRadius: "25px",
                        textTransform: "none",
                        padding: "8px 15px",
                        fontSize: "14px", }}
              onClick={() => {
                setSaveFailed(false);
              }}
            >
              Ok
            </StyledButton>
          </Grid>
        </DialogContent>
      </Dialog>

      {/* Legend for Material Near Expiry Flag */}
      {/* <div style={{ 
        marginTop: "1rem", 
        padding: "0.5rem", 
        backgroundColor: "#f9f9f9", 
        border: "1px solid #e0e0e0", 
        borderRadius: "4px",
        display: "flex",
        alignItems: "center",
        fontSize: "0.875rem"
      }}>
        <Typography variant="caption" style={{ fontSize: "0.875rem", marginRight: "8px" }}>
          Legend:
        </Typography>
        <FlagIcon
          style={{
            color: "yellow",
            fontSize: 20,
            stroke: "black",
            strokeWidth: 1.5,
            marginRight: "8px"
          }}
        />
        <Typography variant="caption" style={{ fontSize: "0.875rem" }}>
          Material near expiry
        </Typography>
      </div> */}
      {/* Info Dialog for Planned Material Batch Number */}
      <Dialog
        open={infoDialogOpen}
        onClose={() => setInfoDialogOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogContent style={{ padding: "24px" }}>
          <Grid container justifyContent="flex-end">
            <Typography
              variant="body2"
              style={{
                fontSize: "1rem",
                fontWeight: 600,
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => setInfoDialogOpen(false)}
            >
              Close <CloseIcon fontSize="large" style={{ color: "#FF0000" }} />
            </Typography>
          </Grid>
          <Grid
            container
            direction="column"
            alignItems="center"
            style={{ marginTop: "16px" }}
          >
            <Typography
              variant="h6"
              style={{ fontWeight: 600, marginBottom: "20px" }}
            >
              Planned Material Batch Number
            </Typography>
            <Typography
              variant="body2"
              style={{ textAlign: "center", lineHeight: "1.6" }}
            >
              Please use this field is to enter Material Batch Number
              <br /> that is not yet present in the inventory. In case of
              multiple
              <br /> Batch Number entry, use comma to separate the values.
            </Typography>
          </Grid>
        </DialogContent>
      </Dialog>

      {/* Electronic Signature Validation Dialog */}
      <BatchAllocationElectronicSignature
        open={electronicSignatureDialog.open}
        onClose={handleCloseElectronicSignature}
        allocationDetails={{
          decision: electronicSignatureDialog.decision,
          poNumber: data?.scheduleLineDetails?.scheduleAgreementNumber || "NA",
        }}
        handleESignatureSuccess={handleElectronicSignatureSuccess}
      />

      {/* Approve/Reject Success Dialog */}
      <Dialog
        open={approveRejectSuccess.open}
        onClose={() => {}}
        maxWidth="sm"
        fullWidth
      >
        <DialogContent style={{ padding: "2rem", textAlign: "center" }}>
          <CheckCircleIcon style={{ fontSize: 60, color: "#399438", marginBottom: "1rem" }} />
          <Typography variant="h6" style={{ fontWeight: 600, marginBottom: "1rem" }}>
            {approveRejectSuccess.type === "Approve" ? "Allocation Approved Successfully" : "Allocation Rejected Successfully"}
          </Typography>
          <Typography variant="body2" style={{ marginBottom: "1.5rem" }}>
            {approveRejectSuccess.type === "Approve" 
              ? "The component allocation has been approved."
              : "The component allocation has been rejected."}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setApproveRejectSuccess({ open: false, type: "" });
              // Trigger data fetch after user closes success dialog
              setIsProcessingApproval(false);
            }}
            style={{ 
              borderRadius: "25px",
                        textTransform: "none",
                        padding: "8px 15px",
                        fontSize: "14px",
            }}
          >
            OK
          </Button>
        </DialogContent>
      </Dialog>


    </React.Fragment>
  );
};

export default LotAllocationTable;
